<template>
  <div class="content">
    <!-- <PageHeader title="Omni Business" subtitle="Ajustes do sistema"/> -->
    <PageHeader title="Chat" subtitle="Ajustes do sistema" />
    <section class="page-content container-fluid">
      <div class="static text-center" v-if="loading">
        <img src="assets/img/loading.gif" />
      </div>
      <template v-else>
        <div class="row">
          <div class="col-lg-2 col-md-2">
            <h3 class="left-title">Preferências</h3>
          </div>
          <div class="col-lg-10 col-md-10">
            <div class="">
              <div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Solicitar tabulação ao finalizar</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" name="notifications-opt" v-model="form.tabulation" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">Ao finalizar um atendimento o agente deverá obrigatoriamente selecionar uma tabulação antes de concluir o atendimento.</p>
                  </div>
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Chat interno</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" name="notifications-opt" v-model="form.internal_chat" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">Com esta opção ativada, será possível utilizar o chat interno em sua empresa</p>
                  </div>
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Fidelização do cliente</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" v-model="retainByChannel" @change="updateLayoutType('list'), changeChannelRetain()" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">
                      Se um cliente utilizar múltiplos canais de comunicação e um desses canais já estiver em atendimento, todos os outros canais serão automaticamente
                      redirecionados para um único atendente, garantindo uma experiência de atendimento coesa.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Fidelizar por HSM</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" :sync="true" v-model="retainByCustomer" @change="updateLayoutType('list'), changeCustomerRetain()" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">
                      Quando um agente envia um HSM para retomar a sessão ou fazer um ativo, o cliente é vinculado exclusivamente à lista desse agente, evitando que seja
                      transferido para outro agente ou que o Chatbot assuma o atendimento.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Layout do atendimento:</h4>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">
                      Escolha como deseja gerenciar os atendimentos atribuídos aos agentes. Optando pela fila, os agentes irão buscar manualmente os clientes na fila geral. Optando
                      pela lista, os atendimentos serão distribuídos automaticamente e de forma igualitária entre os agentes.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0 relative info-quee">
                    <h4 class="card-subtitles" style="padding-left: 0;">Fila</h4>
                    <span class="material-symbols-outlined info-stack">info</span>
                    <img src="/assets/img/icons/tooltip_quee.png" class="image-tooltip-system" />
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" :sync="true" v-model="layoutTypeQueue" @change="updateLayoutType('queue')" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0 relative info-list">
                    <h4 class="card-subtitles" style="padding-left: 0;">Lista</h4>
                    <span class="material-symbols-outlined info-stack">info</span>
                    <img src="/assets/img/icons/tooltip_list.png" class="image-tooltip-system" />
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" :sync="true" v-model="layoutTypeList" @change="updateLayoutType('list')" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do agente</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" name="notifications-opt" v-model="enableMaxAgentResponseTime" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">
                      Ao ativar essa opção, em caso de inatividade do agente a conversa será finalizada após o tempo selecionado. Quando desabilitada a conversa não será finalizada
                      por inatividade.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 p-0 p-l-15 limit-time">
                        Tempo limite:
                      </div>
                      <div class="col-md-2">
                        <div class="clock-input">
                          <span class="material-symbols-outlined">
                            access_time
                          </span>
                          <input type="time" class="form-control limit-input" max="24:00" v-model="form.maxAgentResponseTime" />
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do cliente</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" name="notifications-opt" v-model="enableMaxClientResponseTime" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">Caso o cliente não responda dentro do período definido, o sistema finalizará o atendimento automaticamente.</p>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 p-0 p-l-15 limit-time">
                        Tempo limite:
                      </div>
                      <div class="col-md-2">
                        <div class="clock-input">
                          <span class="material-symbols-outlined">
                            access_time
                          </span>
                          <input type="time" class="form-control limit-input" max="24:00" v-model="form.maxClientResponseTime" />
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Tempo de inatividade</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" name="notifications-opt" v-model="enableMaxDowntimeTime" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">Tempo de espera do bot para ir para a categoria &quot;abandonado&quot;</p>
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-2 p-0 p-l-15 limit-time">
                        Tempo limite:
                      </div>
                      <div class="col-md-2">
                        <div class="clock-input">
                          <span class="material-symbols-outlined">
                            access_time
                          </span>
                          <input type="time" class="form-control limit-input" max="24:00" v-model="form.maxDowntime" />
                        </div>
                      </div>
                    </div>
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row" v-if="!form.queued_enabled">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Aceitar/recusar atendimento atribuído</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" :sync="true" v-model="form.acceptance_option" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <p class="card-info-p">
                      Com esta opção ativada, seu Agente poderá aceitar ou recusar um atendimento, caso seu Agente recuse o atendimento, nosso sistema irá devolver automaticamente
                      para a fila de espera para que seja atribuído a um novo Agente.
                    </p>
                  </div>
                  <div class="col-md-12" v-if="layoutTypeList">
                    <div class="row">
                      <div class="col-md-3 p-0 p-l-15 limit-time">
                        Tempo máximo na lista:
                      </div>
                      <div class="col-md-2">
                        <div class="clock-input">
                          <span class="material-symbols-outlined">
                            access_time
                          </span>
                          <input type="time" class="form-control limit-input" max="24:00" v-model="maxListingTime" @change="checkMaxListingTime()" @blur="checkMaxListingTime()" />
                        </div>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
                <div class="row" v-if="!form.queued_enabled">
                  <div class="col-md-12 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Mensagem:</h4>
                    <textarea
                      class="form-control place-holder-text-area"
                      placeholder="Mensagem quando o cliente é associado a um agente"
                      v-model="form.agent_association_message"
                    ></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <br />
                    <br />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-2">
            <h3 class="left-title">Templates do WhatsApp</h3>
            <p class="card-info-p">
              Defina quais categorias de templates de WhatsApp seus agentes poderão visualizar e enviar pelo atendimento. Gerentes e administradores sempre veem todas as categorias.
            </p>
          </div>
          <div class="col-lg-10 col-md-10">
            <div class="row">
              <div class="col-md-12 p-r-0">
                <h4 class="card-subtitles" style="padding-left: 0;">Restringir categorias visíveis aos agentes</h4>
              </div>
              <div class="col-md-12">
                <p class="card-info-p">
                  Quando desativado, os agentes enxergam templates de todas as categorias. Ative para selecionar manualmente quais categorias os agentes poderão usar.
                </p>
              </div>
              <div class="col-md-12">
                <div class="control-group opt-2 toggle-check">
                  <label class="control control-checkbox">
                    <input type="checkbox" v-model="restrictTemplateCategories" />
                    <div class="control_indicator"></div>
                  </label>
                </div>
              </div>
              <div class="col-md-12" v-if="restrictTemplateCategories">
                <br />
                <div class="row" v-for="cat in templateCategoryOptions" :key="cat.value">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">{{ cat.label }}</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" :value="cat.value" v-model="form.allowed_template_categories" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-2">
            <h3 class="left-title">Notificações</h3>
            <p class="card-info-p">
              Habilite para receber notificações quando um contato executa uma ação específica como mensagens de boas-vindas, alertas, etc.
            </p>
          </div>
          <div class="col-lg-10 col-md-10">
            <div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Notificação de fila</h4>
                </div>
                <div class="col-md-2">
                  <div class="control-group opt-2 toggle-check">
                    <label class="control control-checkbox">
                      <input type="checkbox" v-model="enableQueueNumber" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Ative para poder enviar notificações quando seu cliente estiver na fila de atendimento de um de seus Agentes.</p>
                </div>
                <div class="col-md-12">
                  <h4 class="card-subtitles" style="padding-left: 0;">Mensagem:</h4>
                  <textarea
                    class="form-control place-holder-text-area"
                    v-model="form.message_before_notification_queue"
                    :disabled="!enableQueueNumber"
                    placeholder="Mensagem padrão para seus cliente que aguardam na fila de uma de seus agentes"
                  ></textarea>
                </div>
                <div class="col-md-12">
                  <br />
                </div>
                <div class="col-md-12" v-if="enableQueueNumber">
                  <div class="row">
                    <div class="col-md-12">
                      A partir desse numero de fila será notificada a posição de atendimento
                    </div>
                    <div class="col-md-12">
                      <br />
                    </div>
                    <div class="col-md-4">
                      <input ref="queueNumberRef" type="tel" class="form-control" min="0" max="5000" v-model="form.queue_number_notification" @input="clearInvalids()" />
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Notificação antes do fechamento automatico</h4>
                </div>
                <div class="col-md-2">
                  <div class="control-group opt-2 toggle-check">
                    <label class="control control-checkbox">
                      <input type="checkbox" v-model="enableAutoCloseMessage" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Ative para poder enviar notificações quando não haja interação com seu cliente durante o atendimento</p>
                </div>
                <div class="col-md-12">
                  <br />
                  <div class="row">
                    <div class="col-md-2 p-0 p-l-15 limit-time">
                      Tempo limite:
                    </div>
                    <div class="col-md-2">
                      <div class="clock-input">
                        <span class="material-symbols-outlined">
                          access_time
                        </span>
                        <input
                          type="time"
                          class="form-control limit-input"
                          max="01:00"
                          v-model="form.timeOfPredecessorMessage"
                          @change="checkAutoCloseMessageTime()"
                          @blur="checkAutoCloseMessageTime()"
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
                <div class="col-md-12">
                  <textarea class="form-control place-holder-text-area" v-model="form.autoclose_predecessor_message" :disabled="!enableAutoCloseMessage"></textarea>
                </div>
                <div class="col-md-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Mensagem de espera para o cliente</h4>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Ative as mensagens de espera para os clientes que aguardam fora da fila de atendimento</p>
                </div>
                <div class="col-md-12 p-top-10">
                  <h4 class="card-subtitles" style="padding-left: 0;">Mensagem:</h4>
                  <textarea id="message_customer_wait" class="form-control place-holder-text-area" v-model="form.message_customer_wait"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <br />
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-md-2">
            <h3 class="left-title">Solicitação de dados</h3>
            <p class="card-info-p">
              Utilize mensagens padronizadas para iniciar o atendimento ao cliente e coletar informações pessoais, facilitando assim o trabalho do agente.
            </p>
          </div>
          <div class="col-lg-10 col-md-10">
            <div class="row">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Mensagem de boas-vindas:</h4>
                  </div>
                  <div class="col-md-12">
                    <p class="card-info-p">
                      Crie uma mensagem padrão para seus cliente que aguardam na fila de uma de seus agentes
                    </p>
                  </div>
                  <div class="col-sm-12">
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.welcome_message" id="welcome_message"></textarea>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12 p-r-0"><br /><br /></div>
                </div>
                <div class="form-group">
                  <h5 style="padding-left: 0;">Selecionar Tipo de dado:</h5>
                </div>
                <div class="row">
                  <div class="col-md-12 p-r-0">
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Nome</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" v-model="typeName" @change="changeClientType()" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <p class="card-info-p">
                      Ative a solicitação do nome de seus clientes para iniciar o atendimento.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row" v-if="typeName">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Mensagem solicitando o nome:</h4>
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-12">
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.name_request_text" id="name_request_text"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                  <div class="col-md-12">
                    <h5 class="card-subtitles" style="padding-left: 0; margin-top: 5px;">Mensagem de erro customizada no formato do nome</h5>
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.error_format_name"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Telefone</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" v-model="typePhone" @change="changeClientType()" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <p class="card-info-p">
                      Ative a solicitação do telefone de seus clientes para iniciar o atendimento.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row" v-if="typePhone">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Mensagem solicitando telefone:</h4>
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-12">
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.phone_request_text" id="phone_request_text"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                  <div class="col-md-12">
                    <h5 class="card-subtitles" style="padding-left: 0; margin-top: 5px;">Mensagem de erro customizada no formato do telefone</h5>
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.error_format_phone"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Email</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" v-model="typeEmail" @change="changeClientType()" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <p class="card-info-p">
                      Ative a solicitação do telefone de seus clientes para iniciar o atendimento.
                    </p>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row" v-if="typeEmail">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Mensagem solicitando email:</h4>
                  </div>
                  <div class="col-md-2"></div>
                  <div class="col-md-12">
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.email_request_text" id="email_request_text"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                  <div class="col-md-12">
                    <h5 class="card-subtitles" style="padding-left: 0; margin-top: 5px;">Mensagem de erro customizada no formato do email</h5>
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.error_format_email" id="email_request_text"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row hide">
                  <div class="col-12 col-md-12 custom-messages">
                    <!-- nome -->
                    <template v-if="form.link_client_type !== 'NONE'">
                      <div class="form-group">
                        <h4 class="card-subtitles" style="padding-left: 0;">Mensagem solicitando nome</h4>
                        <textarea type="text" class="form-control place-holder-text-area" v-model="form.name_request_text" id="name_request_text"></textarea>
                        <br />
                      </div>
                      <div class="form-group">
                        <h4 class="card-subtitles" style="padding-left: 0;">Mensagem de erro customizada no formato do nome</h4>
                        <textarea type="text" class="form-control place-holder-text-area" v-model="form.error_format_name" id="xxxxxxxx"></textarea>
                      </div>
                    </template>

                    <!-- telefone -->
                    <template v-if="form.link_client_type === 'BOTH' || form.link_client_type === 'PHONE'">
                      <div class="form-group">
                        <h4 class="card-subtitles" style="padding-left: 0;">Mensagem solicitando telefone</h4>
                        <textarea type="text" class="form-control place-holder-text-area" v-model="form.phone_request_text" id="phone_request_text"></textarea>
                      </div>
                      <div class="form-group">
                        <h4 class="card-subtitles" style="padding-left: 0;">Mensagem de erro customizada no formato do telefone</h4>
                        <textarea type="text" class="form-control place-holder-text-area" v-model="form.error_format_phone" id="error_format_phone"></textarea>
                      </div>
                    </template>

                    <!-- email -->
                    <template v-if="form.link_client_type === 'BOTH' || form.link_client_type === 'EMAIL'">
                      <div class="form-group">
                        <h4 class="card-subtitles" style="padding-left: 0;">Mensagem solicitando email</h4>
                        <textarea type="text" class="form-control place-holder-text-area" v-model="form.email_request_text" id="email_request_text"></textarea>
                      </div>
                      <div class="form-group">
                        <h4 class="card-subtitles" style="padding-left: 0;">Mensagem de erro customizada no formato do email</h4>
                        <textarea type="text" class="form-control place-holder-text-area" v-model="form.error_format_email" id="error_format_email"></textarea>
                      </div>
                    </template>
                  </div>
                </div>
                <div class="col-md-12">
                  <br />
                  <br />
                </div>

                <!-- widget:custom_field -->
                <div class="row">
                  <div class="col-md-10 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Campo customizado no widget</h4>
                  </div>
                  <div class="col-md-2">
                    <div class="control-group opt-2 toggle-check">
                      <label class="control control-checkbox">
                        <input type="checkbox" v-model="form.custom_field_link" />
                        <div class="control_indicator"></div>
                      </label>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <p class="card-info-p">Ative a solicitação de campo customizado para <strong>widget</strong>.</p>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <div class="row" v-if="form.custom_field_link">
                  <div class="col-md-2 p-r-0">
                    <h4 class="card-subtitles" style="padding-left: 0;">Campo customizado:</h4>
                  </div>
                  <div class="col-md-3">
                    <select class="form-control" v-model="form.custom_field">
                      <template v-for="(field, index) in customFields">
                        <option :key="index" :value="field.id">{{ field.name }}</option>
                      </template>
                    </select>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                  <div class="col-md-12">
                    <h5 class="card-subtitles" style="padding-left: 0; margin-top: 5px;">
                      Mensagem de solicitação do campo customizado
                    </h5>
                    <textarea type="text" class="form-control place-holder-text-area" v-model="form.custom_field_request" id="email_request_text"></textarea>
                  </div>
                  <div class="col-md-12">
                    <br />
                  </div>
                </div>
                <!-- widget:custom_field -->
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <br />
          </div>
        </div>
        <div class="row">
          <div class="advance-button c-pointer" @click="(showAdvance = !showAdvance), loadContainerDrag()">
            <h2 class="card-subtitles">Avançado</h2>
            <div class="text-left">
              <span class="material-symbols-outlined c-pointer" v-if="showAdvance">
                keyboard_arrow_up
              </span>
              <span class="material-symbols-outlined c-pointer" v-if="!showAdvance">
                keyboard_arrow_down
              </span>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <br />
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <br />
            <br />
          </div>
        </div>
        <b-collapse v-model="showAdvance">
          <div class="row">
            <div class="col-lg-2 col-md-2">
              <h3 class="left-title">Preferências por Canais</h3>
              <p class="card-info-p">Gerencie seu atendimento por canal</p>
            </div>
            <div class="col-lg-10 col-md-10">
              <div>
                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="card-subtitles">WhatsApp</h2>
                    <div class="text-right">
                      <span class="material-symbols-outlined c-pointer" v-if="whatsVisible" @click="whatsVisible = !whatsVisible">
                        keyboard_arrow_up
                      </span>
                      <span class="material-symbols-outlined c-pointer" v-if="!whatsVisible" @click="whatsVisible = !whatsVisible">
                        keyboard_arrow_down
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <br />
                    <br />
                  </div>
                </div>
                <b-collapse v-model="whatsVisible">
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do agente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.whatsapp.enableMaxAgentResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <p class="card-info-p">
                        Ao ativar essa opção, em caso de inatividade do agente a conversa será finalizada após o tempo selecionado. Quando desabilitada a conversa não será
                        finalizada por inatividade.
                      </p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.whatsapp.maxAgentResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do cliente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.whatsapp.enableMaxClientResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <p class="card-info-p">
                        Caso o cliente não responda dentro do período definido, o sistema finalizará o atendimento automaticamente.
                      </p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.whatsapp.maxClientResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                </b-collapse>
                <div class="row">
                  <div class="col-sm-12"></div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="card-subtitles">Telegram</h2>
                    <div class="text-right">
                      <span class="material-symbols-outlined c-pointer" v-if="telegramVisible" @click="telegramVisible = !telegramVisible">
                        keyboard_arrow_up
                      </span>
                      <span class="material-symbols-outlined c-pointer" v-if="!telegramVisible" @click="telegramVisible = !telegramVisible">
                        keyboard_arrow_down
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <br />
                    <br />
                  </div>
                </div>
                <b-collapse v-model="telegramVisible">
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do agente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.telegram.enableMaxAgentResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <p class="card-info-p">
                        Ao ativar essa opção, em caso de inatividade do agente a conversa será finalizada após o tempo selecionado. Quando desabilitada a conversa não será
                        finalizada por inatividade.
                      </p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.telegram.maxAgentResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do cliente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.telegram.enableMaxClientResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <p class="card-info-p">
                        Caso o cliente não responda dentro do período definido, o sistema finalizará o atendimento automaticamente.
                      </p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.telegram.maxClientResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                </b-collapse>

                <div class="row">
                  <div class="col-sm-12"></div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="card-subtitles">RCS Google</h2>
                    <div class="text-right">
                      <span class="material-symbols-outlined c-pointer" v-if="rcsVisible" @click="rcsVisible = !rcsVisible">
                        keyboard_arrow_up
                      </span>
                      <span class="material-symbols-outlined c-pointer" v-if="!rcsVisible" @click="rcsVisible = !rcsVisible">
                        keyboard_arrow_down
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <br />
                    <br />
                  </div>
                </div>
                <b-collapse v-model="rcsVisible">
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do agente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.rcs.enableMaxAgentResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <p class="card-info-p">
                        Ao ativar essa opção, em caso de inatividade do agente a conversa será finalizada após o tempo selecionado. Quando desabilitada a conversa não será
                        finalizada por inatividade.
                      </p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.rcs.maxAgentResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do cliente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.rcs.enableMaxClientResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <p class="card-info-p">Caso o cliente não responda dentro do período definido, o sistema finalizará o atendimento automaticamente.</p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.rcs.maxClientResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                </b-collapse>
                <div class="row">
                  <div class="col-sm-12"></div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <h2 class="card-subtitles">Widget</h2>
                    <div class="text-right">
                      <span class="material-symbols-outlined c-pointer" v-if="widgetVisible" @click="widgetVisible = !widgetVisible">
                        keyboard_arrow_up
                      </span>
                      <span class="material-symbols-outlined c-pointer" v-if="!widgetVisible" @click="widgetVisible = !widgetVisible">
                        keyboard_arrow_down
                      </span>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <br />
                    <br />
                  </div>
                </div>
                <b-collapse v-model="widgetVisible">
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do agente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.widget.enableMaxAgentResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <p class="card-info-p">
                        Ao ativar essa opção, em caso de inatividade do agente a conversa será finalizada após o tempo selecionado. Quando desabilitada a conversa não será
                        finalizada por inatividade.
                      </p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.widget.maxAgentResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-10 p-r-0">
                      <h4 class="card-subtitles" style="padding-left: 0;">Tempo máximo de resposta do cliente</h4>
                    </div>
                    <div class="col-md-2">
                      <div class="control-group opt-2 toggle-check">
                        <label class="control control-checkbox">
                          <input type="checkbox" name="notifications-opt" v-model="responseTimeChannels.widget.enableMaxClientResponseTime" />
                          <div class="control_indicator"></div>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <p class="card-info-p">Caso o cliente não responda dentro do período definido, o sistema finalizará o atendimento automaticamente.</p>
                    </div>
                    <div class="col-md-12">
                      <div class="row">
                        <div class="col-md-2 p-0 p-l-15 limit-time">
                          Tempo limite:
                        </div>
                        <div class="col-md-2">
                          <div class="clock-input">
                            <span class="material-symbols-outlined">
                              access_time
                            </span>
                            <input type="time" class="form-control limit-input" max="24:00" v-model="responseTimeChannels.widget.maxClientResponseTime" />
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </div>
                </b-collapse>
                <div class="row">
                  <div class="col-sm-12"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" ref="targetExpedient">
            <div class="col-lg-12">
              <br />
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2">
              <h3 class="left-title">Expedientes</h3>
              <p class="card-info-p">
                Escolha as horas e os dias da semana em que deseja que o serviço esteja ativo. Você pode escolher uma estratégia padrão ou personalizar uma você mesmo.
              </p>
            </div>
            <div class="col-lg-10 col-md-10">
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Todos os dias (Padrão)</h4>
                </div>
                <div class="col-md-2">
                  <div class="control-group opt-2 toggle-check">
                    <label class="control control-checkbox">
                      <input type="checkbox" v-model="enableQueueNumber" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Ative ou desative rapidamente o horário comercial.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Departamento:</h4>
                </div>
                <div class="col-md-6">
                  <select-input
                    label="name"
                    v-model="expedient.departments"
                    :reduce="(field) => `${field.id};${field.name}`"
                    :options="departmentsExpedients"
                    :clearable="true"
                    :multiple="false"
                    @input="changeExpedinetDepartment"
                  />
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Defina o departamento</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div v-if="showHours">
                <template v-for="(item, i) in weekdays">
                  <div class="row weekdays" :key="i" style="margin-bottom: 10px;margin-right: 0px;">
                    <div class="col-6 col-sm-2" style="display: flex;">
                      <toggle-button v-model="expedient[item.key]" class="mt5 m-top-4" :sync="true" />
                      <span class="week-day-expedient-name">{{ item.name }}</span>
                    </div>
                    <template v-if="expedient[item.key]">
                      <div class="col-3 col-sm-5 margin-0 padding-0 relative" style="padding-right: 10px !important;">
                        <span class="date-label">De</span>
                        <date-picker v-model="expedient[`begin_hour_${item.key}`]" :config="options" class="form-control input-date" placeholder="--:--" />
                      </div>
                      <div class="col-3 col-sm-5 margin-0 padding-0 relative">
                        <span class="date-label">Até</span>
                        <date-picker v-model="expedient[`end_hour_${item.key}`]" :config="options" class="form-control input-date" placeholder="--:--" />
                      </div>
                    </template>
                    <div class="col-6 col-sm-10 closed holiday-closed" style="padding: 5px; font-variation-settings: 'FILL' 1, 'wght' 700, 'GRAD' 0, 'opsz' 48;" v-else>
                      <div>
                        <span class="material-symbols-outlined">
                          dark_mode
                        </span>
                        Fechado
                      </div>
                    </div>
                    <div class="col-lg-12">
                      <br />
                    </div>
                  </div>
                </template>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-8 p-r-0 time-label">
                  <span class="material-symbols-outlined">language</span>
                  <span class="time-label-span">(GMT-3) Horário Padrão de Brasília</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Não finalizar atendimentos abertos após o horário</h4>
                </div>
                <div class="col-md-2">
                  <div class="control-group opt-2 toggle-check">
                    <label class="control control-checkbox">
                      <input type="checkbox" v-model="expedient.time_end_but_continue" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Caso o cliente esteja inativo, o sistema finalizará o atendimento automaticamente.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Continuar a atender clientes que já estão na fila após o horário</h4>
                </div>
                <div class="col-md-2">
                  <div class="control-group opt-2 toggle-check">
                    <label class="control control-checkbox">
                      <input type="checkbox" v-model="expedient.time_end_but_work_queue" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Ao finalizar um atendimento o agente deverá obrigatóriamente selecionar uma tabulação antes de fechar.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Continuar a atender clientes que já estão na fila após o horário</h4>
                </div>
                <div class="col-md-2">
                  <div class="control-group opt-2 toggle-check">
                    <label class="control control-checkbox">
                      <input type="checkbox" v-model="expedient.time_end_but_work_queue" />
                      <div class="control_indicator"></div>
                    </label>
                  </div>
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Ao finalizar um atendimento o agente deverá obrigatóriamente selecionar uma tabulação antes de fechar.</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Mensagem:</h4>
                </div>
                <div class="col-sm-12">
                  <textarea class="form-control place-holder-text-area" v-model="expedient.message" placeholder="Você foi associado a um agente, logo será atendido."></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 hide">
                  <button class="btn-add-holiday" v-b-modal.modalExpedient><i class="fa fa-plus"></i> <span>Adicionar Expediente</span></button>
                </div>
                <div class="col-sm-12">
                  <h2 class="card-subtitles">Meus expedientes</h2>
                  <div class="text-right">
                    <span class="material-symbols-outlined c-pointer" v-if="expedientVisible" @click="expedientVisible = !expedientVisible">
                      keyboard_arrow_up
                    </span>
                    <span class="material-symbols-outlined c-pointer" v-if="!expedientVisible" @click="expedientVisible = !expedientVisible">
                      keyboard_arrow_down
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <b-collapse v-model="expedientVisible">
                    <div class="card-list-holiday" v-for="(hours, i) in openinghours" :key="i">
                      <div class="card-holiday c-pointer" style="margin-bottom: 5px; flex-direction: column;" @click="hours.visible = !hours.visible">
                        <div class="row padding-0 w100">
                          <div class="col-sm-3 margin-0" style="padding-top: 3px;">
                            <span class="material-symbols-outlined icon-calendar-list">
                              calendar_month
                            </span>
                            <span class="holiday-department" v-if="checkUUID(hours.department_name)">#Geral</span>
                            <span class="holiday-department" v-else>#{{ hours.department_name }}</span>
                          </div>
                          <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;"></div>
                          <div class="card-holiday-title col-sm-5 margin-0">
                            <strong>
                              <span class="holiday-days" v-if="hours.sunday">Dom</span>
                              <span class="holiday-days" v-if="hours.monday">Seg</span>
                              <span class="holiday-days" v-if="hours.tuesday">Ter</span>
                              <span class="holiday-days" v-if="hours.wednesday">Qua</span>
                              <span class="holiday-days" v-if="hours.thursday">Qui</span>
                              <span class="holiday-days" v-if="hours.friday">Sex</span>
                              <span class="holiday-days" v-if="hours.saturday">Sáb</span>
                            </strong>
                          </div>
                          <div class="card-holiday-remove col-sm-1 margin-0">
                            <span class="material-symbols-outlined title c-pointer" style="color: #B51C0A;" @click="removeExpedient(hours.id)">
                              delete
                            </span>
                            <span class="material-symbols-outlined title c-pointer" @click="editExpedient(hours)" style="margin-right: 15px;">
                              edit
                            </span>
                          </div>
                        </div>
                        <div class="w100">
                          <b-collapse v-model="hours.visible">
                            <div class="row padding-0 w100">
                              <div class="card-holiday-title col-sm-12 margin-0">
                                <hr />
                                <h4 class="hour-title-slide">Horários</h4>
                                <strong>
                                  <div v-if="hours.sunday" class="hours-container">
                                    <span class="holiday-days">Dom</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_sunday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_sunday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_sunday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_sunday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="hours.monday" class="hours-container">
                                    <span class="holiday-days" v-if="hours.monday">Seg</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_monday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_monday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_monday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_monday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="hours.tuesday" class="hours-container">
                                    <span class="holiday-days" v-if="hours.tuesday">Ter</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_tuesday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_tuesday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_tuesday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_tuesday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="hours.wednesday" class="hours-container">
                                    <span class="holiday-days" v-if="hours.wednesday">Qua</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_wednesday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_wednesday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_wednesday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_wednesday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="hours.thursday" class="hours-container">
                                    <span class="holiday-days">Qui</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_thursday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_thursday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_thursday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_thursday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="hours.friday" class="hours-container">
                                    <span class="holiday-days">Sex</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_friday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_friday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_friday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_friday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <div v-if="hours.saturday" class="hours-container">
                                    <span class="holiday-days">Sáb</span>
                                    <div class="col-sm-3 margin-0 card-holiday-date-container" style="padding-top: 3px;">
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.begin_hour_saturday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.begin_hour_saturday, 'a') }}</span>
                                      </div>
                                      <div class="card-holiday-arrow-right">
                                        <i class="fa fa-chevron-right"></i>
                                      </div>
                                      <div class="card-holiday-date">
                                        {{ hourFormat(hours.end_hour_saturday, 'hh:mm') }}
                                      </div>
                                      <div class="card-holiday-date-period">
                                        <span class="card-holiday-date-period-am">{{ hourFormat(hours.end_hour_saturday, 'a') }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </strong>
                              </div>
                            </div>
                          </b-collapse>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="row" ref="targetHoliday">
            <div class="col-sm-12">
              <br />
              <br />
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2">
              <h3 class="left-title">Feriados</h3>
              <p class="card-info-p">
                Use para controle específico e otimize para cada janela de tempo única.
              </p>
            </div>
            <div class="col-lg-10 col-md-10">
              <div class="row">
                <div class="col-md-6 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Título:</h4>
                </div>
                <div class="col-md-6">
                  <input class="form-control" placeholder="Ex.: Feriado de Natal" v-model="holiday.name" />
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Defina o título</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Departamento:</h4>
                </div>
                <div class="col-md-6">
                  <select-input
                    label="name"
                    v-model="holiday.departments"
                    :reduce="(field) => `${field.id};${field.name}`"
                    :options="departmentsHolidays"
                    :clearable="true"
                    :multiple="false"
                    @input="changeHolidayDepartment"
                  />
                </div>
                <div class="col-sm-12">
                  <p class="card-info-p">Defina o departamento</p>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div></div>
              <div class="row">
                <div class="col-sm-12 col-md-12  col-lg-7 p-r-0">
                  <div class="calendar-container">
                    <h4 class="label-info-calendar">SELECIONAR DATA</h4>
                    <Calendar v-model="dateCalendar" @input="changeHolidayDates" inline showWeek selectionMode="range" dateFormat="dd/mm/yy" />
                  </div>
                </div>
                <div class="col-sm-12 col-md-12 col-lg-5 p-r-0">
                  <div class="calendar-container calendar-container-time">
                    <h4 class="label-info-calendar">SELECIONAR HORA</h4>
                    <clock-picker :mode="24" :defaultHour="defaultHour" :defaultFocused="true" :defaultMinute="defaultMinute" :onTimeChange="timeChangeHandler" />
                    <div style="clear:both;"></div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-8 p-r-0 time-label">
                  <span class="material-symbols-outlined">language</span>
                  <span class="time-label-span">(GMT-3) Horário Padrão de Brasília</span>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-md-10 p-r-0">
                  <h4 class="card-subtitles" style="padding-left: 0;">Mensagem:</h4>
                </div>
                <div class="col-sm-12">
                  <textarea class="form-control place-holder-text-area" v-model="holiday.message" placeholder="Você foi associado a um agente, logo será atendido."></textarea>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <h2 class="card-subtitles">Meus feriados</h2>
                  <div class="text-right">
                    <span class="material-symbols-outlined c-pointer" v-if="holidaysVisible" @click="holidaysVisible = !holidaysVisible">
                      keyboard_arrow_up
                    </span>
                    <span class="material-symbols-outlined c-pointer" v-if="!holidaysVisible" @click="holidaysVisible = !holidaysVisible">
                      keyboard_arrow_down
                    </span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <b-collapse v-model="holidaysVisible">
                    <div class="card-list-holiday" v-for="(holiday, i) in holidays" :key="i">
                      <div class="card-holiday" style="padding-top: 5px;padding-bottom: 5px; margin-bottom: 10px;">
                        <div class="row padding-0 w100">
                          <div class="col-sm-1 margin-0 card-holiday-info-days" style="padding-top: 3px;padding-left: 20px;">
                            <div>
                              <span>{{ weekday(holiday.date_begin) }}</span>
                            </div>
                            <div>
                              <h4>{{ dateFormat(holiday.date_begin, 'DD') }}</h4>
                            </div>
                          </div>
                          <div class="col-sm-8 margin-0 department-name-holiday">
                            <span class="holiday-department">#{{ holiday.name }}</span>
                          </div>
                          <div class="col-sm-2 margin-0 card-holiday-date-container" style="padding-top: 25px;">
                            <div class="card-holiday-date">
                              {{ dateFormat(holiday.date_begin, 'hh:mm') }}
                            </div>
                            <div class="card-holiday-date-period">
                              <span class="card-holiday-date-period-am">{{ dateFormat(holiday.date_begin, 'a') }}</span>
                            </div>
                            <div class="card-holiday-arrow-right hide">
                              <i class="fa fa-chevron-right"></i>
                            </div>
                            <div class="card-holiday-date hide">
                              12:00
                            </div>
                            <div class="card-holiday-date-period hide">
                              <span class="card-holiday-date-period-am">AM</span>
                            </div>
                          </div>
                          <div class="card-holiday-remove col-sm-1 margin-0" style="padding-top: 25px;">
                            <span class="material-symbols-outlined title c-pointer" style="color: #B51C0A;" @click="removeHoliday(holiday.id)">
                              delete
                            </span>
                            <span class="material-symbols-outlined title c-pointer hide" @click="editHoliday(holiday)" style="margin-right: 15px;">
                              edit
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                </div>
              </div>
              <div class="row hide">
                <div class="col-sm-12">
                  <button class="btn-add-holiday" v-b-modal.modalHoliday><i class="fa fa-plus"></i> <span>Adicionar Feriado</span></button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <br />
                  <br />
                </div>
              </div>
              <div class="row hide">
                <div class="col-sm-12">
                  <div v-if="!hasAddHoliday">
                    <div v-for="(holiday, i) in holidays" :key="i">
                      <div class="card-list-holiday">
                        <div class="card card-holiday">
                          <div>
                            <img class="img-fluid img-icon-card" src="@/assets/icons/date.png" />
                          </div>
                          <div class="card-holiday-title" style="width: 80%;">
                            <span>{{ holiday.name }}</span>
                            <strong>{{ holiday.date_begin | date('DD/MM/YYYY HH:mm:ss') }} - {{ holiday.date_end | date('DD/MM/YYYY HH:mm:ss') }}</strong>
                          </div>
                          <div class="card-holiday-date-container hide" style="margin-top: 8px;">
                            <div class="card-holiday-arrow-right">
                              <i class="fa fa-chevron-right"></i>
                            </div>
                          </div>
                        </div>
                        <div class="card-holiday-remove" @click="removeHoliday(holiday.id)">
                          <i class="fa fa-times"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <br />
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2">
              <h3 class="left-title">Tabulações</h3>
              <p class="card-info-p">
                Crie tabulações para organizar informações no seu atendimento.
              </p>
            </div>
            <div class="col-lg-10 col-md-10">
              <div class="row">
                <div class="col-md-8">
                  <h4 class="card-subtitles" style="padding-left: 0; float: none;">Adicionar tabulação:</h4>
                  <p class="card-info-p">Defina uma nova variável para o seu sistema de atendimento</p>
                </div>
                <div class="col-sm-4">
                  <div class="input-new-var">
                    <div class="input-group mb-3">
                      <input type="text" class="form-control" placeholder="Ex.: SMS" v-model="tabForm.name" />
                      <div class="input-group-append">
                        <button class="btn btn-primary btn-icon" type="button" @click="createTab"><span class="material-symbols-outlined">add</span></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <br />
                </div>
                <div class="col-md-12">
                  <h4 class="card-subtitles" style="padding-left: 0; float: none;">Minhas tabulações:</h4>
                  <div class="text-right">
                    <span class="material-symbols-outlined c-pointer" v-if="tabsVisible" @click="tabsVisible = !tabsVisible">
                      keyboard_arrow_up
                    </span>
                    <span class="material-symbols-outlined c-pointer" v-if="!tabsVisible" @click="tabsVisible = !tabsVisible">
                      keyboard_arrow_down
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <br />
                </div>
                <div class="col-md-12">
                  <b-collapse v-model="tabsVisible">
                    <div v-for="(tab, i) in tabs" :key="i">
                      <span class="tag-vars">{{ tab.name }} <span class="material-symbols-outlined c-pointer font-close icon-delete" @click="removeTab(tab)">delete</span></span>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <br />
              <br />
            </div>
          </div>
          <div class="row">
            <div class="col-lg-2 col-md-2">
              <h3 class="left-title">Tags</h3>
              <p class="card-info-p">
                Crie tags para categorizar informações sobre os clientes e suas interações.
              </p>
            </div>
            <div class="col-lg-10 col-md-10">
              <div class="row">
                <div class="col-md-8">
                  <h4 class="card-subtitles" style="padding-left: 0; float: none;">Adicionar Tag:</h4>
                  <p class="card-info-p">Defina uma nova tag para o seu sistema de atendimento</p>
                </div>
                <div class="col-sm-4">
                  <div class="input-new-var">
                    <div class="input-group mb-3">
                      <input type="text" class="form-control" placeholder="Ex.: Informações" v-model="tagForm.name" />
                      <select class="form-control" v-model="tagForm.tabulation_id">
                        <option value="" selected>Tabulação</option>
                        <option v-for="(tab, i) in tabs" :key="i" :value="tab.id">
                          {{ tab.name }}
                        </option>
                      </select>
                      <div class="input-group-append">
                        <button class="btn btn-primary btn-icon" type="button" @click="createTag"><span class="material-symbols-outlined">add</span></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <br />
                </div>
                <div class="col-md-12">
                  <h4 class="card-subtitles" style="padding-left: 0; float: none;">Minhas tags:</h4>
                  <div class="text-right">
                    <span class="material-symbols-outlined c-pointer" v-if="tagsVisible" @click="tagsVisible = !tagsVisible">
                      keyboard_arrow_up
                    </span>
                    <span class="material-symbols-outlined c-pointer" v-if="!tagsVisible" @click="tagsVisible = !tagsVisible">
                      keyboard_arrow_down
                    </span>
                  </div>
                </div>
                <div class="col-md-12">
                  <br />
                </div>
                <div class="col-md-12">
                  <b-collapse v-model="tagsVisible">
                    <div id="sortable" @drop="drop">
                      <div class="row">
                        <div class="col-4" v-for="(tagGroup, i) in tagsGroup" :key="i">
                          <div class="tab-card" :data-group="tagGroup.id">
                            <h4>{{ tagGroup.name }}</h4>
                            <div v-for="(tag, j) in tagGroup.tags" :key="j">
                              <span class="tag-vars tag-vars-dragable" draggable="true" @dragstart="drag" :data-node="JSON.stringify(tag)"
                                ><span class="material-symbols-outlined font-close icon-delete">drag_indicator</span>{{ tag.name }}
                                <span class="material-symbols-outlined c-pointer font-close icon-delete-tag" @click="removeTag(tag)">delete</span
                                ><span class="material-symbols-outlined c-pointer font-close icon-delete-tag" @click="removeTagFromTab(tag)" style="margin-left: 16px;"
                                  >close</span
                                ></span
                              >
                            </div>
                            <div style="clear:both;"></div>
                          </div>
                        </div>
                      </div>
                      <div v-for="(tag, i) in tags" :key="i">
                        <span class="tag-vars tag-vars-dragable" draggable="true" @dragstart="drag" :data-node="JSON.stringify(tag)"
                          ><span class="material-symbols-outlined font-close icon-delete">drag_indicator</span> {{ tag.name }}
                          <span class="material-symbols-outlined c-pointer font-close icon-delete" @click="removeTag(tag)">delete</span></span
                        >
                      </div>
                      <div style="clear:both;"></div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
          </div>
          <div class="row cards hide">
            <div class="col-lg-4">
              <div class="card card-height">
                <h3 class="card-header">Expedientes</h3>
                <button class="btn-add-holiday" v-b-modal.modalExpedient><i class="fa fa-plus"></i> <span>Adicionar Expediente</span></button>
                <div class="card-body block-el">
                  <div class="card-list-holiday" v-for="(hours, i) in openinghours" :key="i">
                    <div class="card card-holiday">
                      <div>
                        <img class="img-fluid img-icon-card" src="@/assets/icons/date.png" />
                      </div>
                      <div class="card-holiday-title">
                        <span>Expediente</span>
                        <strong>
                          <span style="float: left;font-size: 13px;margin-right: 5px;">Dias:&nbsp;&nbsp;</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.sunday">Dom</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.monday">Seg</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.tuesday">Ter</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.wednesday">Qua</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.thursday">Qui</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.friday">Sex</span>
                          <span style="font-weight: 200;float: left;font-size: 13px;margin-right: 5px;" v-if="hours.saturday">Sáb</span>
                        </strong>
                      </div>
                      <div class="card-holiday-date-container hide">
                        <div class="card-holiday-date">
                          12:00
                        </div>
                        <div class="card-holiday-date-period">
                          <span class="card-holiday-date-period-am">AM</span>
                          <span class="card-holiday-date-period-pm">PM</span>
                        </div>
                        <div class="card-holiday-arrow-right">
                          <i class="fa fa-chevron-right"></i>
                        </div>
                      </div>
                    </div>
                    <div class="card-holiday-remove">
                      <i class="fa fa-times" @click="removeExpedient(hours.id)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 hide">
              <div class="card card-height">
                <div>
                  <h3 class="card-header" style="float: left;">Etiqueta</h3>
                </div>
                <div class="card-body block-el" style="padding-top: 0px;">
                  <span style="font-size: 14px; color: #000000;">Selectionar tipo de etiqueta</span>
                  <div class="tab-container-tags">
                    <div class="tab-container-tags-item" @click="tabTags = 'tab'" :class="{ 'tags-item-active': tabTags == 'tab' }">
                      <span>Tabulações <i class="fa fa-times"></i></span>
                    </div>
                    <div class="tab-container-tags-item" @click="tabTags = 'tag'" :class="{ 'tags-item-active': tabTags == 'tag' }">
                      <span>Tags <i class="fa fa-times"></i></span>
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  <div class="card-list-holiday" :class="{ 'show-tab-holiday': tabTags == 'tab', 'hide-tab-holiday': tabTags !== 'tab' }">
                    <div class="card-list-holiday-buttons">
                      <button class="btn-add-holiday to-right" v-b-modal.modalTab><i class="fa fa-plus"></i> <span>Adicionar tabulação</span></button>
                      <div style="clear: both;"></div>
                    </div>
                    <div class="row" style="margin-bottom: 20px;">
                      <template v-for="(tab, i) in tabs">
                        <div class="col-sm-12 d-flex align-items-center mb-4" :key="i" v-if="tab.name !== 'GENERIC' && tab.name !== null">
                          <span class="tab-item-name">{{ tab.name }}</span>
                          <dropdown>
                            <template v-slot:text>
                              <span class="material-symbols-outlined title">
                                more_vert
                              </span>
                            </template>
                            <template #items>
                              <a class="dropdown-item" v-b-modal.modalTabEdit @click="tabForm = tab"><i class="fa fa-edit"></i> Editar</a>
                              <a class="dropdown-item" @click="removeTab(tab)"><i class="fa fa-trash"></i> Excluir</a>
                            </template>
                          </dropdown>
                        </div>
                      </template>
                    </div>
                  </div>
                  <div class="card-list-holiday" :class="{ 'show-tab-holiday': tabTags == 'tag', 'hide-tab-holiday': tabTags !== 'tag' }">
                    <div class="card-list-holiday-buttons">
                      <button class="btn-add-holiday to-right" v-b-modal.modalTag><i class="fa fa-plus"></i> <span>Adicionar tag</span></button>
                      <div style="clear: both;"></div>
                    </div>
                    <div class="row">
                      <template v-for="(tag, i) in tags">
                        <div class="col-sm-12 d-flex align-items-center mb-4" :key="i">
                          <span class="tag-item-name">{{ tag.name }}</span>
                          <dropdown>
                            <template v-slot:text>
                              <span class="material-symbols-outlined title">
                                more_vert
                              </span>
                            </template>
                            <template #items>
                              <a class="dropdown-item" v-b-modal.modalTagEdit @click="tagForm = tag"><i class="fa fa-edit"></i> Editar</a>
                              <a class="dropdown-item" @click="removeTag(tag)"><i class="fa fa-trash"></i> Excluir</a>
                            </template>
                          </dropdown>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>

        <div class="card-bottom-btns-save">
          <div class="row">
            <div class="col-sm-8 card-bottom-btns-save-icon">
              <!-- <img src="assets/img/icons/system_settigns.png" /> -->
              <svg xmlns="http://www.w3.org/2000/svg" width="34.188" height="30.602" viewBox="0 0 34.188 30.602">
                <path
                  id="system_settings"
                  data-name="system settigns"
                  d="M-309.652,659.629a.586.586,0,0,1-.4-.149.624.624,0,0,1-.211-.358l-.294-2.018a5.306,5.306,0,0,1-.936-.431,5.225,5.225,0,0,1-.852-.6l-1.85.863a.668.668,0,0,1-.453.01.618.618,0,0,1-.346-.284l-1.136-2.019a.524.524,0,0,1-.063-.431.6.6,0,0,1,.252-.346l1.684-1.263a3.923,3.923,0,0,1-.063-.472c-.015-.175-.021-.34-.021-.495s.006-.3.021-.474a4.82,4.82,0,0,1,.063-.495l-1.684-1.261a.6.6,0,0,1-.252-.347.525.525,0,0,1,.063-.431l1.136-2a.683.683,0,0,1,.346-.294.515.515,0,0,1,.431.022l1.852.84a5.786,5.786,0,0,1,.863-.589,5.33,5.33,0,0,1,.926-.421l.315-2.04a.633.633,0,0,1,.211-.358.585.585,0,0,1,.4-.147h2.271a.6.6,0,0,1,.389.147.611.611,0,0,1,.221.358l.294,2.04a7.42,7.42,0,0,1,.936.421,3.831,3.831,0,0,1,.832.589l1.893-.84a.545.545,0,0,1,.431-.032.633.633,0,0,1,.347.284l1.136,2a.579.579,0,0,1,.074.442.545.545,0,0,1-.264.358l-1.7,1.241c.029.168.05.337.063.5s.022.33.022.484-.007.294-.022.462-.034.344-.063.525l1.7,1.242a.549.549,0,0,1,.241.346.552.552,0,0,1-.074.431l-1.135,2.019a.62.62,0,0,1-.347.284.538.538,0,0,1-.431-.031l-1.872-.842a7.249,7.249,0,0,1-.842.6,3.564,3.564,0,0,1-.926.409l-.294,2.04a.6.6,0,0,1-.221.358.6.6,0,0,1-.389.149Zm-.568-9.678a2.292,2.292,0,0,0-.695,1.684,2.287,2.287,0,0,0,.695,1.682,2.287,2.287,0,0,0,1.682.695,2.287,2.287,0,0,0,1.682-.695,2.287,2.287,0,0,0,.695-1.682,2.292,2.292,0,0,0-.695-1.684,2.291,2.291,0,0,0-1.682-.693A2.291,2.291,0,0,0-310.22,649.951Zm-13.053,4.186a2.3,2.3,0,0,1-1.769-.845,2.382,2.382,0,0,1-.5-1.977,2.4,2.4,0,0,1,2.4-1.887h1.481a2.324,2.324,0,0,1,2.025,1.178h1.858a9.993,9.993,0,0,0-.074,1.213,9.85,9.85,0,0,0,.066,1.141h-1.849a2.36,2.36,0,0,1-2.027,1.177Zm5.537-7.062a1.575,1.575,0,0,1-1.571-1.575v-5.486a1.573,1.573,0,0,1,1.571-1.572h.784a3.144,3.144,0,0,1,3.138,3.144v2.3a9.9,9.9,0,0,0-2.807,3.173,3.188,3.188,0,0,1-.331.018Zm-10.2,0a3.147,3.147,0,0,1-3.14-3.145v-2.345a3.144,3.144,0,0,1,3.14-3.143l.74,0a1.571,1.571,0,0,1,1.569,1.571l.044,5.49a1.573,1.573,0,0,1-1.569,1.573ZM-335,643.542v-1.961a13.226,13.226,0,0,1,3.73-8.8,12.223,12.223,0,0,1,8.826-3.759,12.222,12.222,0,0,1,8.826,3.759,13.225,13.225,0,0,1,3.73,8.8v.6a9.741,9.741,0,0,0-2.355.77v-1.367a10.208,10.208,0,0,0-10.2-10.192,10.208,10.208,0,0,0-10.2,10.192v1.961a1.249,1.249,0,0,1-1.222,1.177A1.171,1.171,0,0,1-335,643.542Z"
                  transform="translate(335 -629.026)"
                />
              </svg>
              <h4>Ajustes do Sistema</h4>
            </div>
            <div class="col-sm-4 text-right d-flex align-items-center">
              <button class="btn btn-yup-purple ml-auto mr-3" @click="save()">Salvar alterações</button>
            </div>
          </div>
        </div>
      </template>
    </section>
    <b-modal id="modalTag" title="Nova tag" hide-footer>
      <div class="py-2">
        <label class="form-label label-bold" style="margin-top: 0px;">Tag</label>
        <input v-model="tagForm.name" class="form-control" />
      </div>
      <div class="py-2">
        <button class="btn btn-primary btn-save-blue margin-0" @click="saveTag()">Salvar</button>
        <button class="btn btn-primary btn-save-outline margin-0" @click="$bvModal.hide('modalTag')">Cancelar</button>
      </div>
      <br />
    </b-modal>
    <b-modal id="modalTagEdit" title="Editar tag" hide-footer>
      <div class="py-2">
        <label class="form-label label-bold" style="margin-top: 0px;">Tag</label>
        <input v-model="tagForm.name" class="form-control" />
      </div>
      <div class="py-2">
        <button class="btn btn-primary btn-save-blue margin-0" @click="saveTagEdit()">Salvar</button>
        <button class="btn btn-primary btn-save-outline margin-0" @click="$bvModal.hide('modalTagEdit')">Cancelar</button>
      </div>
      <br />
    </b-modal>
  </div>
</template>

<script>
// import Emojis from '@/components/Emojis.vue';
import PageHeader from '@/components/rebranding/PageHeader.vue';
import { ToggleButton } from 'vue-js-toggle-button';
import axios from '@/plugins/axios';
import SelectInput from '@/components/SelectInput.vue';
import datePicker from 'vue-bootstrap-datetimepicker';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import Swal from 'sweetalert2';
import Dropdown from '@/components/Dropdown.vue';
import Calendar from 'primevue/calendar';
import 'primevue/resources/themes/lara-light-indigo/theme.css';
import ClockPicker from '@/components/clock-picker';
import moment from 'moment';

export default {
  name: 'System',
  components: {
    // InfiniteLoading,
    // Emojis,
    PageHeader,
    ToggleButton,
    SelectInput,
    datePicker,
    Dropdown,
    Calendar,
    ClockPicker,
  },
  data() {
    return {
      showHours: false,
      expedientCurrent: {},
      defaultHour: new Date().getHours(),
      defaultMinute: new Date().getMinutes(),
      expedientVisible: true,
      holidaysVisible: true,
      showAdvance: false,
      tabsVisible: true,
      tagsVisible: true,
      whatsVisible: false,
      telegramVisible: false,
      rcsVisible: false,
      widgetVisible: false,
      tabForm: {},
      typeName: false,
      typeEmail: false,
      typePhone: false,
      tabTags: 'tab',
      inputValue: '10:10 PM',
      options: {
        format: 'HH:mm',
        useCurrent: true,
        showClear: true,
        showClose: true,
      },
      expedient: {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,

        begin_hour_sunday: '09:00',
        begin_hour_monday: '09:00',
        begin_hour_tuesday: '09:00',
        begin_hour_wednesday: '09:00',
        begin_hour_thursday: '09:00',
        begin_hour_friday: '09:00',
        begin_hour_saturday: '09:00',

        end_hour_sunday: '12:00',
        end_hour_monday: '18:00',
        end_hour_tuesday: '18:00',
        end_hour_wednesday: '18:00',
        end_hour_thursday: '18:00',
        end_hour_friday: '18:00',
        end_hour_saturday: '12:00',

        departments: '', // departamentos selecionados
        message: 'Não encontrei nenhum atendente disponível. 🫤',
        time_end_but_continue: false,
        time_end_but_work_queue: false,
      },
      dateBegin: null,
      dateCalendar: new Date(),
      dateEnd: null,
      hourBegin: '00:01',
      hourEnd: '23:59',
      holidays: [],
      hasAddHoliday: false,
      hasAddExpedient: false,
      formDepartmentsTimeout: 0,
      fetched: true,
      content: null,
      tabs: [],
      holiday: {
        departments: [],
      },
      departments: [],
      departmentsHolidays: [],
      departmentsExpedients: [], // departamentos selecionaveis
      loading: true,
      enableMaxAgentResponseTime: false,
      enableMaxClientResponseTime: false,
      enableMaxDowntimeTime: false,
      enableQueueNumber: false,
      enableAutoCloseMessage: false,
      lastQueuedEnabled: false,
      layoutTypeQueue: false,
      layoutTypeList: false,
      maxListingTime: 0,
      tags: [],
      tagForm: {
        tabulation_id: '',
      },
      retainByChannel: false,
      retainByCustomer: false,
      responseTimeChannels: {
        whatsapp: {
          maxAgent: 0,
          maxClient: 0,
          enable: false,
        },
        telegram: {
          maxAgent: 0,
          maxClient: 0,
          enable: false,
        },
        widget: {
          maxAgent: 0,
          maxClient: 0,
          enable: false,
        },
        rcs: {
          maxAgent: 0,
          maxClient: 0,
          enable: false,
        },
      },

      form: {
        welcome_message: '',
        maxAgentResponseTime: '24:00',
        maxClientResponseTime: '24:00',
        tabulation: false,
        maxDowntime: '24:00',
        maxListingTime: '00:00',
        queue_number_notification: 0,
        message_before_notification_queue: '',
        time_of_predecessor_message: 0,
        autoclose_predecessor_message: '',
        acceptance_option: false,

        queued_enabled: true,
        message_customer_wait: '',

        agent_association_message: '',

        link_client_type: 'BOTH',

        name_request_text: '',
        error_format_name: '',

        email_request_text: '',
        error_format_email: '',

        phone_request_text: '',
        error_format_phone: '',

        retain_by_channel: false,
        retain_customer: false,

        custom_field: '',
        custom_field_link: false,
        custom_field_request: '',

        allowed_template_categories: [],
      },
      restrictTemplateCategories: false,
      tagsGroup: [],
      tagsAlone: [],
      openinghours: [],
      customFields: [],
      draggedItem: null,
    };
  },
  computed: {
    account() {
      return this.$store.state.account;
    },
    noGeneral() {
      const depts = this.holiday.departments;
      const main = this.mainDepartment;

      if (depts === null || depts.length < 2 || !main) return true;

      const j = depts.length;

      for (let i = 0; i < j; i += 1) {
        if (depts[i] === main) {
          this.updateFormDepartments(depts[i]);
          return false;
        }
      }

      return true;
    },
    weekdays() {
      // No futuro traduzam apenas o campo LABEL
      return [
        { label: 'D', key: 'sunday', name: 'Domingo' },
        { label: 'S', key: 'monday', name: 'Segunda' },
        { label: 'T', key: 'tuesday', name: 'Terça' },
        { label: 'Q', key: 'wednesday', name: 'Quarta' },
        { label: 'Q', key: 'thursday', name: 'Quinta' },
        { label: 'S', key: 'friday', name: 'Sexta' },
        { label: 'S', key: 'saturday', name: 'Sábado' },
      ];
    },
    templateCategoryOptions() {
      return [
        { value: 'MARKETING', label: 'Marketing' },
        { value: 'UTILITY', label: 'Utilidade' },
        { value: 'AUTHENTICATION', label: 'Autenticação' },
      ];
    },
  },
  mounted() {
    this.getTabs();

    axios()
      .get('webchat/system')
      .then((response) => {
        this.loading = false;

        console.log('SAVE!!', 'loader', response.data);

        if (response.data.live.max_time_agent !== '86400') this.enableMaxAgentResponseTime = true;

        if (response.data.live.max_time_client !== '86400') this.enableMaxClientResponseTime = true;

        if (response.data.middleware.downtime !== '0') this.enableMaxDowntimeTime = true;

        let hA = Math.floor(response.data.live.max_time_agent / 60);
        let hC = Math.floor(response.data.live.max_time_client / 60);
        let hD = Math.floor(response.data.middleware.downtime / 60);

        let mA = response.data.live.max_time_agent % 60;
        let mC = response.data.live.max_time_client % 60;
        let mD = response.data.middleware.downtime % 60;

        if (hA < 10) hA = `0${hA}`;
        if (hC < 10) hC = `0${hC}`;
        if (hD < 10) hD = `0${hD}`;

        if (mA < 10) mA = `0${mA}`;
        if (mC < 10) mC = `0${mC}`;
        if (mD < 10) mD = `0${mD}`;

        const maxAgentResponseTime = `${hA}:${mA}`;
        const maxClientResponseTime = `${hC}:${mC}`;
        const maxDowntime = `${hD}:${mD}`;

        this.retainByChannel = response.data.live.retain_by_channel;
        this.retainByCustomer = response.data.live.retain_customer;

        this.form.retain_by_channel = this.retainByChannel;
        this.form.retain_customer = this.retainByCustomer;

        this.form.maxAgentResponseTime = maxAgentResponseTime;
        this.form.maxClientResponseTime = maxClientResponseTime;
        this.form.tabulation = response.data.live.must_tabulate_enabled;
        this.form.maxDowntime = maxDowntime;

        const numberQueue = response.data.live.queue_number_notification;
        this.enableQueueNumber = numberQueue > 0;

        this.form.queue_number_notification = numberQueue > 0 ? numberQueue : 0;
        this.form.message_before_notification_queue = response.data.live.message_before_notification_queue;

        const timeAutoClose = response.data.live.time_of_predecessor_message;
        this.enableAutoCloseMessage = timeAutoClose > 0;

        let hT = Math.floor(timeAutoClose / 60);
        let mT = response.data.live.max_time_agent % 60;

        if (hT < 10) hT = `0${hT}`;

        if (mT < 10) mT = `0${mT}`;

        this.form.timeOfPredecessorMessage = `${hT}:${mT}`;

        this.form.time_of_predecessor_message = timeAutoClose > 0 ? timeAutoClose : 0;
        this.form.autoclose_predecessor_message = response.data.live.autoclose_predecessor_message;

        this.lastQueuedEnabled = response.data.live.queued_enabled ?? true;
        this.form.queued_enabled = this.lastQueuedEnabled;

        this.layoutTypeQueue = this.lastQueuedEnabled;
        this.layoutTypeList = !this.lastQueuedEnabled;

        const maxListingTime = response.data.live.max_listing_time;

        let hMLT = Math.floor(maxListingTime / 60);
        let mMLT = maxListingTime % 60;

        // console.log('maxListingTime', { maxListingTime, hMLT, mMLT });

        if (hMLT < 10) hMLT = `0${hMLT}`;
        if (mMLT < 10) mMLT = `0${mMLT}`;

        this.form.max_listing_time = maxListingTime;
        this.maxListingTime = `${hMLT}:${mMLT}`;

        this.form.acceptance_option = response.data.live.acceptance_option ?? true;

        this.form.message_customer_wait = response.data.live.message_customer_wait ?? '';
        this.form.agent_association_message = response.data.live.agent_association_message ?? '';

        const allowed = response.data.live.allowed_template_categories;
        if (Array.isArray(allowed)) {
          this.form.allowed_template_categories = allowed;
          this.restrictTemplateCategories = true;
        } else {
          this.form.allowed_template_categories = [];
          this.restrictTemplateCategories = false;
        }

        console.log(response.data.middleware.link_client_type);

        this.form.link_client_type = response.data.middleware.link_client_type;
        if (this.form.link_client_type === 'NAME' || this.form.link_client_type === 'NAME_PHONE' || this.form.link_client_type === 'NAME_EMAIL') {
          this.typeName = true;
        }
        if (
          this.form.link_client_type === 'PHONE' ||
          this.form.link_client_type === 'NAME_PHONE' ||
          this.form.link_client_type === 'EMAIL_PHONE' ||
          this.form.link_client_type === 'BOTH'
        ) {
          this.typePhone = true;
        }
        if (
          this.form.link_client_type === 'EMAIL' ||
          this.form.link_client_type === 'EMAIL_PHONE' ||
          this.form.link_client_type === 'NAME_EMAIL' ||
          this.form.link_client_type === 'BOTH'
        ) {
          this.typeEmail = true;
        }
        if (this.form.link_client_type === 'NONE') {
          this.typeEmail = false;
          this.typeName = false;
          this.typePhone = false;
        }
        if (this.form.link_client_type === 'BOTH') {
          this.typeEmail = true;
          this.typeName = true;
          this.typePhone = true;
        }

        if (this.typeName) {
          this.form.link_client_type = 'NAME';
        }
        if (this.typePhone) {
          this.form.link_client_type = 'PHONE';
        }
        if (this.typeEmail) {
          this.form.link_client_type = 'EMAIL';
        }

        if (this.typePhone && this.typeEmail) {
          this.form.link_client_type = 'EMAIL_PHONE';
        }
        if (this.typePhone && this.typeName) {
          this.form.link_client_type = 'NAME_PHONE';
        }
        if (this.typeName && this.typeEmail) {
          this.form.link_client_type = 'NAME_EMAIL';
        }
        if (this.typeName && this.typePhone) {
          this.form.link_client_type = 'NAME_PHONE';
        }

        if (this.typeName && this.typePhone && this.typeEmail) {
          this.form.link_client_type = 'BOTH';
        }

        if (!this.typeName && !this.typePhone && !this.typeEmail) {
          this.form.link_client_type = 'NONE';
        }

        this.form.name_request_text = response.data.middleware.name_request_text;
        this.form.error_format_name = response.data.middleware.error_format_name;

        this.form.email_request_text = response.data.middleware.email_request_text;
        this.form.error_format_email = response.data.middleware.error_format_email;

        this.form.phone_request_text = response.data.middleware.phone_request_text;
        this.form.error_format_phone = response.data.middleware.error_format_phone;

        this.form.welcome_message = response.data.middleware.welcome_message;

        this.form.custom_field = response.data.middleware.custom_field;
        this.form.custom_field_link = response.data.middleware.custom_field_link;
        this.form.custom_field_request = response.data.middleware.custom_field_request;

        console.log('SYSTEM', this.form, response.data);
      })
      .catch((error) => {
        this.loading = false;
        console.error(error);
      });
    this.fetch();
  },
  destroyed() {},
  watch: {
    dateBegin(newVal, oldVal) {
      if (this.hourBegin) {
        this.holiday.date_begin = `${newVal}T${this.hourBegin}`;
        this.holiday.date_end = `${newVal}T23:59`;
      }
    },
    dateEnd(newVal, oldVal) {
      if (newVal !== 'Invalid date') {
        if (this.hourEnd) this.holiday.date_end = `${newVal}T${this.hourEnd}`;
      }
    },
    hourBegin(newVal, oldVal) {
      if (this.hourBegin) this.holiday.date_begin = `${this.dateBegin}T${newVal}`;
    },
    hourEnd(newVal, oldVal) {
      // if (this.dateEnd) this.holiday.date_end = `${this.dateEnd}T${newVal}`;
    },
  },
  methods: {
    drop(ev) {
      console.log(ev.dataTransfer.getData('node'));
      console.log('Dropou', ev.target);
      console.log('Dropou', ev.target.getAttribute('data-group'));
      const tag = JSON.parse(ev.dataTransfer.getData('node'));
      if (ev.target.getAttribute('data-group') != null) {
        ev.target.insertBefore(this.draggedItem, ev.target.childNodes[1]);
        const tabulationId = ev.target.getAttribute('data-group');
        this.saveTagEdit(tag.id, {
          name: tag.name,
          tabulation_id: tabulationId,
          account_id: tag.account_id,
        });
      } else if (tag.tabulation_id !== null && tag.tabulation_id !== '') {
        this.saveTagEdit(tag.id, {
          name: tag.name,
          tabulation_id: '',
          account_id: tag.account_id,
        });
        this.getTabs();
      }
    },
    removeTagFromTab(tag) {
      this.saveTagEdit(tag.id, {
        name: tag.name,
        tabulation_id: '',
        account_id: tag.account_id,
      });
      this.getTabs();
    },
    drag(ev) {
      ev.dataTransfer.setData('node', ev.target.getAttribute('data-node'));
      console.log('Drag', ev.target.getAttribute('data-node'));
    },
    loadContainerDrag() {
      const sortableList = document.getElementById('sortable');
      sortableList.addEventListener('dragstart', (e) => {
        e.dataTransfer.setData('node', e.target.getAttribute('data-node'));
        this.draggedItem = e.target;
        console.log('draggedItem', this.draggedItem);
        setTimeout(() => {
          e.target.style.display = 'none';
        }, 0);
      });

      sortableList.addEventListener('dragend', (e) => {
        setTimeout(() => {
          e.target.style.display = '';
          // this.draggedItem = null;
        }, 0);
      });

      sortableList.addEventListener('dragover', (e) => {
        e.preventDefault();
        const afterElement = this.getDragAfterElement(sortableList, e.clientY);
        const currentElement = document.querySelector('.dragging');
        console.log('currentElement', currentElement);
        console.log('afterElement', afterElement);
        if (afterElement == null) {
          sortableList.appendChild(this.draggedItem);
        }
      });
    },
    getDragAfterElement(container, y) {
      const draggableElements = [...container.querySelectorAll('div:not(.dragging)')];
      return draggableElements.reduce(
        (closest, child) => {
          const box = child.getBoundingClientRect();
          const offset = y - box.top - box.height / 2;
          if (offset < 0 && offset > closest.offset) {
            return {
              offset,
              element: child,
            };
          }
          return closest;
        },
        {
          offset: Number.NEGATIVE_INFINITY,
        },
      ).element;
    },
    getTabs() {
      axios()
        .get('webchat/tabs')
        .then(
          (response) => {
            this.tabs = response.data;
            console.log('webchat/tabs', response.data);
            this.getTags();
          },
          (error) => {
            console.log(error);
            this.content = error;
          },
        )
        .finally(() => {
          this.fetched = true;
        });
    },
    editHoliday(holiday) {
      this.holiday = holiday;
      this.$refs.targetHoliday.scrollIntoView({ behavior: 'smooth' });
      this.departments.forEach((department) => {
        if (holiday.department_id === department.id) {
          holiday.departments = `${department.id};${department.name}`;
        }
      });
      this.defaultHour = this.dateFormat(holiday.date_begin, 'hh');
      this.defaultMinute = this.dateFormat(holiday.date_begin, 'mm');
      const time = {
        hour: this.defaultHour,
        minute: this.defaultMinute,
      };
      this.$emit('clock.change', time);
      this.$forceUpdate();
    },
    changeHolidayDates(date) {
      console.log(date);
      this.dateBegin = moment(date[0], 'DD/MM/YYYY').format('YYYY-MM-DD');
      this.dateEnd = moment(date[1], 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    dateFormat(date, format = 'hh:mm:ss a') {
      return moment(date).format(format);
    },
    hourFormat(date, format = 'hh:mm:ss a') {
      return moment(date, 'hh:mm').format(format);
    },
    weekday(date) {
      const dateMoment = moment(date);
      const day = dateMoment.day();
      switch (day) {
        case 0:
          return 'Dom';
        case 1:
          return 'Seg';
        case 2:
          return 'Ter';
        case 3:
          return 'Qua';
        case 4:
          return 'Qui';
        case 5:
          return 'Sex';
        case 6:
          return 'Sáb';
        default:
          break;
      }
      return null;
    },
    changeExpedinetDepartment(department) {
      this.expedient = {
        sunday: false,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,

        begin_hour_sunday: '09:00',
        begin_hour_monday: '09:00',
        begin_hour_tuesday: '09:00',
        begin_hour_wednesday: '09:00',
        begin_hour_thursday: '09:00',
        begin_hour_friday: '09:00',
        begin_hour_saturday: '09:00',

        end_hour_sunday: '12:00',
        end_hour_monday: '18:00',
        end_hour_tuesday: '18:00',
        end_hour_wednesday: '18:00',
        end_hour_thursday: '18:00',
        end_hour_friday: '18:00',
        end_hour_saturday: '12:00',

        departments: department, // departamentos selecionados
        message: 'Não encontrei nenhum atendente disponível.  🫤',
        time_end_but_continue: false,
        time_end_but_work_queue: false,
      };
      this.showHours = true;
      const newDepartment = department.split(';');
      console.log(this.expedient);
      console.log(department.split(';'));
      this.expedient.isEditing = false;
      this.openinghours.forEach((hour) => {
        if (hour.department_id === newDepartment[0]) {
          this.expedient = hour;
          this.expedient.departments = department;
        } else {
          this.expedient.departments = department;
          this.expedient.department_id = newDepartment[0];
        }
      });
      this.$forceUpdate();
    },
    changeHolidayDepartment(department) {
      const newDepartment = department.split(';');
      this.holidays.forEach((hour) => {
        if (hour.department_id === newDepartment[0]) {
          this.holiday = hour;
          this.holiday.departments = department;
        } else {
          this.holiday.departments = department;
        }
      });
    },
    checkUUID(id) {
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;
      return regexExp.test(id);
    },
    onFocusChange() {
      return false;
    },
    timeChangeHandler(time) {
      const interval = time.hour < 12 ? 'AM' : 'PM';
      time.hour = time.hour.toString().padStart(2, '0');
      time.minute = time.minute.toString().padStart(2, '0');
      this.hourBegin = `${time.hour}:${time.minute}`;
      this.hourEnd = `${time.hour}:${time.minute}`;
      console.log(this.hourBegin);
    },
    changeChannelRetain() {
      this.form.retain_by_channel = this.retainByChannel;
    },
    changeCustomerRetain() {
      this.form.retain_customer = this.retainByCustomer;
    },
    getTags() {
      this.tagsGroup = [];
      this.tagsAlone = [];
      return axios()
        .get('webchat/tags-response')
        .then((response) => {
          const tags = response.data;
          tags.forEach((tag) => {
            if (tag.tabulation_id !== '' && tag.tabulation_id !== null) {
              const tabulation = this.tabs.filter((tab) => tab.id === tag.tabulation_id);
              let tagGroup = this.tagsGroup.filter((tagGroup) => tagGroup.id === tag.tabulation_id);
              console.log('tagGroup', tagGroup);
              if (tagGroup.length > 0) {
                tagGroup[0].tags.push(tag);
              } else {
                tagGroup = {
                  name: tabulation[0].name,
                  id: tag.tabulation_id,
                  tags: [tag],
                };
                this.tagsGroup.push(tagGroup);
              }
              console.log('tagsGroup', this.tagsGroup);
            }
          });
          this.tags = tags.filter((tag) => tag.tabulation_id === '' || tag.tabulation_id === null);
        });
    },
    saveTagEdit(id, data) {
      axios()
        .put(`webchat/tags-response/${id}`, data)
        .then(
          () => {
            this.$toast.show({
              title: 'Sucesso',
              content: 'Tag salva com sucesso',
              type: 'success',
            });
          },
          (error) => {
            this.$toast.show({
              title: `Erro ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        );
    },
    saveTag() {
      axios()
        .post('webchat/tags-response', this.tagForm)
        .then(
          () => {
            this.$toast.show({
              title: 'Sucesso',
              content: 'Tag criada com sucesso',
              type: 'success',
            });
            this.$bvModal.hide('modalTag');
            this.getTabs();
          },
          (error) => {
            this.$bvModal.hide('modalTag');
            this.$toast.show({
              title: `Erro ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        );
    },
    checkMaxListingTime() {
      const placeholder = this.maxListingTime;
      const [hourA, minA] = placeholder.split(':').map((value) => parseInt(value, 10));
      const time = `${hourA * 60 + minA}`;

      this.form.max_listing_time = time;
    },
    changeClientType() {
      if (this.typeName) {
        this.form.link_client_type = 'NAME';
      }
      if (this.typePhone) {
        this.form.link_client_type = 'PHONE';
      }
      if (this.typeEmail) {
        this.form.link_client_type = 'EMAIL';
      }

      if (this.typePhone && this.typeEmail) {
        this.form.link_client_type = 'EMAIL_PHONE';
      }
      if (this.typePhone && this.typeName) {
        this.form.link_client_type = 'NAME_PHONE';
      }
      if (this.typeName && this.typeEmail) {
        this.form.link_client_type = 'NAME_EMAIL';
      }
      if (this.typeName && this.typePhone) {
        this.form.link_client_type = 'NAME_PHONE';
      }

      if (this.typeName === true && this.typePhone === true && this.typeEmail === true) {
        this.form.link_client_type = 'BOTH';
      }

      if (this.typeName === false && this.typePhone === false && this.typeEmail === false) {
        this.form.link_client_type = 'NONE';
        console.log('Aqio');
      }
      this.$forceUpdate();
      console.log(this.form.link_client_type);
    },
    saveTab() {
      axios()
        .post('webchat/tabs/create', this.tabForm)
        .then(
          () => {
            this.$toast.show({
              title: 'Sucesso',
              content: 'Tabulação criada com sucesso',
              type: 'success',
            });
            this.$bvModal.hide('modalTab');
          },
          (error) => {
            this.$bvModal.hide('modalTab');
            this.$toast.show({
              title: `Erro ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        );
    },
    saveTabEdit(id) {
      axios()
        .put(`webchat/tabs/${id}/room`, this.tabForm)
        .then(
          () => {
            this.$toast.show({
              title: 'Sucesso',
              content: 'Tabulação salva com sucesso',
              type: 'success',
            });
            this.$bvModal.hide('saveTabEdit');
          },
          (error) => {
            this.$bvModal.hide('saveTabEdit');
            this.$toast.show({
              title: `Erro ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        );
    },
    editExpedient(expedient) {
      this.expedient = expedient;
      this.expedient.isEditing = true;
      this.showHours = true;
      this.$refs.targetExpedient.scrollIntoView({ behavior: 'smooth' });
      this.departments.forEach((department) => {
        if (expedient.department_id === department.id) {
          this.expedient.departments = department;
        }
      });
    },
    removeExpedient(id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: 'Deseja deletar esse horário permanentemente. Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          axios()
            .delete(`webchat/openinghours/${id}`)
            .then(
              (response) => {
                this.loading = false;
                Swal.fire('Excluído!', 'Horário excluído', 'success');
                this.fetch();
              },
              (error) => {
                this.loading = false;
                this.$toast.show({
                  title: 'Erro',
                  content: error.message,
                  type: 'danger',
                });
              },
            );
        }
      });
    },
    fetchHoliday() {
      this.departmentsHolidays = [];
      this.departments.forEach((department) => {
        this.departmentsHolidays.push(department);
      });
      axios()
        .get('webchat/holidays')
        .then((response) => {
          this.loading = false;
          console.log('Holidays', response.data);
          this.holidays = response.data;
          let hasGeral = false;
          this.holidays.forEach((holiday) => {
            this.departmentsHolidays.forEach((department, index) => {
              // if (holiday.department_id === department.id) {
              //   this.departmentsHolidays.splice(index, 1);
              // }
              if (this.checkUUID(holiday.department_name)) {
                hasGeral = true;
              }
            });
          });
          if (hasGeral) {
            this.departmentsHolidays = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          console.error('Holidays', error);
        });
    },
    fetchExpedients() {
      /* this.departments.forEach((department) => {
        this.departmentsExpedients.push(department);
      }); */
      axios()
        .get('webchat/openinghours')
        .then((response) => {
          this.loading = false;
          this.openinghours = response.data;
          let hasGeral = false;
          this.departmentsExpedients = [];
          for (let i = 0; i < this.departments.length; i += 1) {
            this.departmentsExpedients.push(this.departments[i]);
          }
          this.openinghours.forEach((expedient) => {
            this.departmentsExpedients.forEach((department, index) => {
              if (expedient.department_id === department.id) {
                this.departmentsExpedients.splice(index, 1);
              }
              if (this.checkUUID(expedient.department_name)) {
                hasGeral = true;
              }
            });
          });
          if (hasGeral) {
            this.departmentsExpedients = [];
          }
          console.log('departmentsExpedients', this.departmentsExpedients);
        })
        .catch((error) => {
          this.loading = false;
          console.error('OpeningHours', error);
        });
    },
    fetchCustomFields() {
      axios()
        .get('/contacts/custom-field')
        .then((response) => {
          this.customFields = [];

          const customFields = this.customFields;

          response.data?.forEach((field) => {
            if (field.id && field.name) {
              customFields.push({
                id: field.id,
                name: field.name,
              });
            }
          });
        });
    },
    validate() {
      if (!this.holiday.name) return this.error('Defina o nome para a(s) data(s)', 'Feriado');

      if (!this.holiday.date_begin || !this.holiday.date_end) return this.error('Defina as datas', 'Feriado');

      if (!this.holiday.departments.length) return this.error('Selecione pelo menos um departamento', 'Feriado');

      if (!this.holiday.message) return this.error('Defina a mensagem alternativa', 'Feriado');

      return true;
    },
    saveHoliday() {
      if (!this.validate()) return;

      axios()
        .post('webchat/holidays/create', this.holiday)
        .then((response) => {
          this.loading = false;
          console.log('Holidays', response.data);
          this.$toast.show({
            title: 'Feriados',
            content: 'Feriado(s) cadastrado(s) para o(s) departamento(s)',
            type: 'success',
          });
          this.holiday = {};
          this.fetch();
          this.$bvModal.hide('modalHoliday');
        })
        .catch((error) => {
          this.loading = false;
          console.error('Holidays', error);
          this.$toast.show({
            title: 'Feriados',
            content: 'Erro ao cadastrar feriado(s)',
            type: 'danger',
          });
        });
    },
    error(message, name) {
      this.$toast.show({
        title: `Erro ao tentar criar/atualizar ${name}`,
        content: message,
        type: 'danger',
      });
      return false;
    },
    removeHoliday(id) {
      Swal.fire({
        title: 'Tem certeza?',
        text: 'Deseja deletar esse horário permanentemente. Você não poderá reverter isso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim, excluir!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          axios()
            .delete(`webchat/holidays/${id}`)
            .then(
              (response) => {
                this.loading = false;
                Swal.fire('Excluído!', 'Horário excluído', 'success');
                this.fetchHoliday();
              },
              (error) => {
                this.loading = false;
                this.$toast.show({
                  title: 'Erro',
                  content: error.message,
                  type: 'danger',
                });
              },
            );
        }
      });
    },
    removeTab(tab) {
      Swal.fire({
        title: `Remover tabulação "${tab.name}"`,
        text: 'Essa ação não poderá ser desfeita',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
      }).then((result) => {
        if (result.value) {
          this.fetched = false;

          axios()
            .delete(`webchat/tabs/${tab.id}`)
            .then(
              (response) => {
                console.log('webchat/tabs', response.data);
                setTimeout(() => {
                  this.$live.requestTabs();
                }, 1);
                return this.getTabs();
              },
              (error) => {
                console.log(error);
                this.content = error;
              },
            )
            .finally(() => {
              this.fetched = true;
            });
        }
      });
    },
    removeTag(tag) {
      Swal.fire({
        title: `Excluir tag "${tag.name}"`,
        text: 'Essa ação não poderá ser desfeita',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sim',
      }).then((result) => {
        if (result.value) {
          this.fetched = false;

          axios()
            .delete(`webchat/tags-response/${tag.id}`)
            .then(
              (response) => {
                console.log('webchat/tags-response', response.data);
                return this.getTabs();
              },
              (error) => {
                console.log(error);
                this.content = error;
              },
            )
            .finally(() => {
              this.fetched = true;
            });
        }
      });
    },
    validateExpendient() {
      // if (!this.form.begin_hour || !this.form.end_hour) return this.error('Defina o horário');
      const expedient = this.expedient;
      console.log('expedient.departments', expedient.departments);
      if (expedient.departments.length === 0) return this.error('Selecione pelo menos um departamento', 'Expediente');

      if (!expedient.message) return this.error('Defina a mensagem alternativa', 'Expediente');

      if (!expedient.monday && !expedient.saturday && !expedient.sunday && !expedient.friday && !expedient.thursday && !expedient.tuesday && !expedient.wednesday) {
        return this.error('Selecione pelo menos um dia da semana', 'Expediente');
      }

      const weekdays = this.weekdays;
      const j = weekdays.length;

      for (let i = 0; i < j; i += 1) {
        const weekday = weekdays[i];

        if (expedient[weekday.key] && (!expedient[`begin_hour_${weekday.key}`] || !expedient[`begin_hour_${weekday.key}`])) {
          return this.error(`Selecione o horário de abertura para ${weekday.label}`, 'Expediente');
        }

        if (expedient[weekday.key] && (!expedient[`end_hour_${weekday.key}`] || !expedient[`end_hour_${weekday.key}`])) {
          return this.error(`Selecione o horário de fechamento para ${expedient.label}`, 'Expediente');
        }
      }

      return true;
    },
    saveExpedient() {
      if (!this.validateExpendient()) return;
      axios()
        .post('webchat/openinghours/create', this.expedient)
        .then((response) => {
          console.log('OpeningHours', response.data);
          this.fetch();
          this.$toast.show({
            title: 'Expediente',
            content: 'Horário(s) cadastrado(s) para o(s) departamento(s)',
            type: 'success',
          });
          this.$bvModal.hide('modalExpedient');
          this.expedient = {};
        })
        .catch((error) => {
          this.loading = false;
          const message = error?.response?.data?.message ?? error.message;
          console.error('OpeningHours', message);
          this.$toast.show({
            title: 'Expediente',
            content: message,
            type: 'danger',
          });
        });
    },
    fetch() {
      axios()
        .get('webchat/departments')
        .then((response) => {
          this.loading = false;

          const departments = [];

          response.data.forEach((department) => {
            console.log('Holidays', department);

            departments.push({
              id: department.id,
              name: department.name,
            });
          });

          this.departments = departments;

          this.fetchHoliday();
          this.fetchExpedients();
          this.fetchCustomFields();
        })
        .catch((error) => {
          this.loading = false;
          console.error('Holidays', error);
        });
    },
    updateFormDepartments(department) {
      if (this.formDepartmentsTimeout) clearTimeout(this.formDepartmentsTimeout);

      this.formDepartmentsTimeout = setTimeout(() => {
        this.form.departments = [department];
      }, 10);
    },
    updateLayoutType(type) {
      if (type === 'queue') {
        this.layoutTypeList = !this.layoutTypeQueue;
      } else if (type === 'list') {
        this.layoutTypeQueue = !this.layoutTypeList;
      }

      console.log('this.layoutTypeQueue', this.layoutTypeQueue);
      console.log('this.layoutTypeList', this.layoutTypeList);

      this.form.queued_enabled = this.layoutTypeQueue;
    },
    checkAutoCloseMessageTime() {
      const placeholder = this.form.timeOfPredecessorMessage;
      const [hourA, minA] = placeholder.split(':').map((value) => parseInt(value, 10));
      const time = `${hourA * 60 + minA}`;

      this.form.time_of_predecessor_message = time;

      if (time > 60 || time < 0) {
        this.form.timeOfPredecessorMessage = '00:00';
        this.form.time_of_predecessor_message = '0';
      }
    },
    clearInvalids() {
      const ref = this.$refs.queueNumberRef;
      const value = parseInt(ref.value, 10);

      if (!value || Number.isNaN(value)) ref.value = '';
    },
    createTab() {
      axios()
        .post('webchat/tabs/create', this.tabForm)
        .then(
          () => {
            this.$bvModal.hide('modalTab');
            this.$toast.show({
              title: 'Sucesso',
              content: 'Tabulação criada com sucesso',
              type: 'success',
            });
            this.getTabs();
            this.tabForm.name = '';
          },
          (error) => {
            this.$bvModal.hide('modalTab');
            this.$toast.show({
              title: `Erro ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        );
    },
    createTag() {
      axios()
        .post('webchat/tags-response', this.tagForm)
        .then(
          () => {
            this.$bvModal.hide('modalTag');
            this.$toast.show({
              title: 'Sucesso',
              content: 'Tag criada com sucesso',
              type: 'success',
            });
            this.tagForm.name = '';
            this.tagForm.tabulation_id = '';
            this.getTabs();
          },
          (error) => {
            this.$bvModal.hide('modalTag');
            this.$toast.show({
              title: `Erro ${error.code}`,
              content: error.message,
              type: 'danger',
            });
          },
        );
    },
    save() {
      this.showHours = false;
      if (!this.typePhone && !this.typeEmail) {
        this.$toast.show({
          title: 'Tipo de dados',
          content: 'Email ou Telefone devem ser obrigatórios em "Tipo de dados"',
          type: 'danger',
        });
        return;
      }

      if (this.typePhone && (!this.form.phone_request_text || !this.form.error_format_phone)) {
        this.$toast.show({
          title: 'Tipo de dados (Telefone)',
          content: 'Verifique os campos "Mensagem solicitando telefone" e "Mensagem de erro customizada no formato do telefone"',
          type: 'danger',
        });
        return;
      }

      if (this.typeEmail && (!this.form.email_request_text || !this.form.error_format_email)) {
        this.$toast.show({
          title: 'Tipo de dados (Email)',
          content: 'Verifique os campos "Mensagem solicitando email" e "Mensagem de erro customizada no formato do email"',
          type: 'danger',
        });
        return;
      }

      this.loading = true;

      console.log(this.form);
      if (!this.enableQueueNumber) {
        this.form.queue_number_notification = '0';
      } else {
        this.enableQueueNumber = this.form.queue_number_notification > 0;
      }

      console.log('system update', this.form, this.enableQueueNumber);

      const [hourA, minA] = this.form.maxAgentResponseTime.split(':').map((value) => parseInt(value, 10));
      const [hourC, minC] = this.form.maxClientResponseTime.split(':').map((value) => parseInt(value, 10));
      const [hourD, minD] = this.form.maxDowntime.split(':').map((value) => parseInt(value, 10));

      axios()
        .put('webchat/system', {
          max_time_agent: {
            type: 'M',
            value: !this.enableMaxAgentResponseTime ? '86400' : `${hourA * 60 + minA}`,
          },
          max_time_client: {
            type: 'M',
            value: !this.enableMaxClientResponseTime ? '86400' : `${hourC * 60 + minC}`,
          },
          must_tabulate_enabled: this.form.tabulation,
          max_downtime: !this.enableMaxDowntimeTime ? '0' : `${hourD * 60 + minD}`,
          queue_number_notification: this.form.queue_number_notification,
          message_before_notification_queue: this.form.message_before_notification_queue,
          time_of_predecessor_message: !this.enableAutoCloseMessage ? '0' : this.form.time_of_predecessor_message,
          autoclose_predecessor_message: this.form.autoclose_predecessor_message,
          queued_enabled: this.form.queued_enabled,
          message_customer_wait: this.form.message_customer_wait,
          agent_association_message: this.form.agent_association_message,
          link_client_type: this.form.link_client_type,
          name_request_text: this.form.name_request_text,
          error_format_name: this.form.error_format_name,
          email_request_text: this.form.email_request_text,
          error_format_email: this.form.error_format_email,
          phone_request_text: this.form.phone_request_text,
          error_format_phone: this.form.error_format_phone,
          retain_by_channel: this.form.retain_by_channel,
          retain_customer: this.form.retain_customer,
          max_listing_time: this.form.max_listing_time,
          acceptance_option: this.form.acceptance_option,
          welcome_message: this.form.welcome_message,
          custom_field: this.form.custom_field,
          custom_field_link: this.form.custom_field_link,
          custom_field_request: this.form.custom_field_request,
          allowed_template_categories: this.restrictTemplateCategories
            ? this.form.allowed_template_categories
            : null,
        })
        .then((response) => {
          this.loading = false;
          this.reconnect();
          console.log(response);
          this.$toast.show({
            title: 'Sucesso',
            content: 'Dados salvo com sucesso',
            type: 'success',
          });
        })
        .catch((error) => {
          this.loading = false;
          console.error(error);
        });
      console.log(this.expedient, 'this.expedient');
      if (this.expedient.departments !== '') {
        if (!this.expedient.isEditing) {
          if (!this.validateExpendient()) {
            this.showHours = true;
            this.$refs.targetExpedient.scrollIntoView({ behavior: 'smooth' });
            return;
          }
          const newDepartment = this.expedient.departments.split(';');
          axios()
            .post('webchat/openinghours/create', {
              ...this.expedient,
              departments: [this.expedient.departments],
            })
            .then((response) => {
              this.expedient = {};
              this.fetchExpedients();
            })
            .catch((error) => {
              this.loading = false;
              const message = error?.response?.data?.message ?? error.message;
              this.showHours = true;
              console.error('OpeningHours', message);
              this.$toast.show({
                title: 'Expediente',
                content: message,
                type: 'danger',
              });
            });
        } else {
          if (!this.validateExpendient()) {
            this.showHours = true;
            this.$refs.targetExpedient.scrollIntoView({ behavior: 'smooth' });
            return;
          }
          axios()
            .put('webchat/openinghours/update', {
              ...this.expedient,
              departments: [`${this.expedient.departments.id};${this.expedient.departments.name}`],
            })
            .then((response) => {
              this.expedient = {};
              this.fetchExpedients();
            })
            .catch((error) => {
              this.loading = false;
              const message = error?.response?.data?.message ?? error.message;
              console.error('OpeningHours', message);
              this.$toast.show({
                title: 'Expediente',
                content: message,
                type: 'danger',
              });
            });
        }
      }
      if (this.holiday.departments != null && this.holiday.departments.length > 0) {
        if (!this.validate()) return;

        axios()
          .post('webchat/holidays/create', {
            ...this.holiday,
            departments: [this.holiday.departments],
          })
          .then((response) => {
            this.loading = false;
            console.log('Holidays', response.data);
            this.holiday = {};
            this.fetchHoliday();
          })
          .catch((error) => {
            this.loading = false;
            console.error('Holidays', error);
            this.$toast.show({
              title: 'Feriados',
              content: 'Erro ao cadastrar feriado(s)',
              type: 'danger',
            });
          });
      }
      if (this.tagForm.name) {
        axios()
          .post('webchat/tags-response', this.tagForm)
          .then(
            () => {
              this.tagForm.name = '';
              this.getTabs();
            },
            (error) => {
              this.$bvModal.hide('modalTag');
              this.$toast.show({
                title: `Erro ${error.code}`,
                content: error.message,
                type: 'danger',
              });
            },
          );
      }
      if (this.tabForm.name) {
        axios()
          .post('webchat/tabs/create', this.tabForm)
          .then(
            () => {
              this.getTabs();
              this.tabForm.name = '';
            },
            (error) => {
              this.$bvModal.hide('modalTab');
              this.$toast.show({
                title: `Erro ${error.code}`,
                content: error.message,
                type: 'danger',
              });
            },
          );
      }
    },
    reconnect() {
      if (this.lastQueuedEnabled !== this.form.queued_enabled) {
        this.lastQueuedEnabled = this.form.queued_enabled;
        this.$live.reconnect();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.qt-block-ui {
  min-height: 200px;
}

.custom-messages-type {
  max-width: 200px;
}

.custom-messages-type,
.custom-messages > :nth-child(2n) {
  margin-bottom: 3.2rem;
}

.cards {
  .card {
    min-height: 240px;
  }
}

.img-icon-card {
  width: 40px;
}

.card-holiday {
  min-height: 0px !important;
  padding: 15px;
  display: flex;
  flex-direction: row;
}

.card-holiday-title {
  padding-left: 15px;
}

.card-holiday-title span {
  color: #3f536e;
  font-size: 15px;
  display: block;
}

.card-holiday-title strong {
  color: #707070;
  font-size: 10px;
}

.darkmode .card-holiday-title strong {
  color: var(--gray-font-color);
}

.card-holiday-date {
  font-size: 14px;
  color: #0d0519;
  font-weight: 400;
}

.card-holiday-date-container {
  display: flex;
  flex-direction: row;
}

.card-holiday-date-period-am {
  display: block;
  font-size: 8px;
  color: #0d0519;
  margin-left: 2px;
  text-transform: uppercase;
}

.card-holiday-date-period-pm {
  display: block;
  font-size: 10px;
  color: #ccc;
  text-transform: uppercase;
}

.card-holiday-date {
  height: 26px;
  margin-left: 10px;
}

.card-holiday-arrow-right i {
  color: #697077;
  font-size: 12px;
}

.card-holiday-arrow-right {
  margin-left: 5px;
  margin-top: -2px;
}

.c-pointer {
  cursor: pointer !important;
}

.btn-add-holiday {
  background: none;
  border: none;
  color: #752de6;
  text-align: right;
  margin-right: 15px;
  font-size: 14px;
}

.btn-add-holiday i {
  color: #752de6;
}

.card-list-holiday .card-holiday {
  float: left;
  border: #e5e5e5 solid 1px;
  border-radius: 8px;
}

.card-list-holiday .card-holiday-remove {
  float: left;
  padding: 0px;
  text-align: right;
}

.card-holiday-remove .title {
  float: right;
  display: block;
}

.card-list-holiday .card-holiday-remove i {
  color: #9ca7b0;
  display: block;
  cursor: pointer;
}

.card-holiday {
  width: 100%;
}

.w100 {
  width: 100% !important;
}

.card-list-info h4 {
  color: #000000;
  font-size: 14px;
  font-weight: normal;
}

.card-list-info p {
  color: #707070;
  font-size: 14px;
}

.qt-block-ui-white {
  background: #fff;
  text-align: center;
  padding: 10px;
  box-shadow: 0px 3px 6px #0000001a;
}

.card-bottom-btns-save {
  width: 90%;
  height: 60px;

  background: var(--background-3) 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px #00000029;
  border: 1px solid var(--background-3);
  border-radius: 4px;
  opacity: 1;
  position: fixed;
  bottom: 10px;
  z-index: 2;
}

.btn-save-blue {
  background: #752de6 !important;
  margin-bottom: 10px;
  margin: 10px;
}

.card-bottom-btns-save-icon {
  display: flex;
}

.card-bottom-btns-save {
}

.card-bottom-btns-save-icon img {
  width: 40px;
  height: 35px;
}

.card-bottom-btns-save-icon h4 {
  font-size: 15px;
  margin-left: 10px;
  margin-top: 5px;
}

.card-bottom-btns-save-icon {
  padding: 15px;
  padding-left: 30px;
}

.p-0 {
  padding: 0 !important;
}

.p-top-10 {
  padding-top: 15px !important;
}

.v-switch-core {
  background-color: #752de6 !important;
}

.label-bold {
  font-weight: bold;
  margin-top: 20px;
}

.margin-0 {
  margin: 0 !important;
}

.btn-save-outline {
  margin-left: 10px !important;
  color: #9ca7b0 !important;
  background: #fff !important;
  border: 1px #9ca7b0 solid !important;
}

button:focus {
  outline: 0 !important;
}

.week-day-expedient {
  display: block;
  border: solid 2px #752de6;
  color: #752de6;
  font-weight: bolder;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 5px;
  margin-left: 5px;
  height: 28px;
  width: 30px;
  text-align: center;
}

.week-day-expedient-name {
  color: #0d0519;
  font-size: 14px;
  font-weight: 400;
  margin-left: 10px;
  margin-top: 5px;
}

.m-top-4 {
  margin-top: 4px !important;
}

.card-header {
  font-size: 26px !important;
  font-weight: 500 !important;
}

.card-subtitles {
  color: #0d0519;
  font-size: 14px;
  font-weight: 400;
}

.card-info-p {
  color: #aaaaaa;
  font-size: 12px;
  font-weight: 400;
  display: block !important;
}

.p-l-15 {
  padding-left: 15px !important;
}

.w-60 {
  width: 60%;
}

.limit-time {
  padding-top: 3px !important;
  color: #0d0519;
  font-size: 14px;
  font-weight: 400;
}

.darkmode .limit-time {
  color: var(--gray-font-color);
}

.clock-limit {
  float: left;
  width: 25px;
  margin-top: 3px;
}

.limit-input {
  float: left;
  margin-left: 10px;
  height: auto;
  border-color: #c8c8c8 !important;
}

.card-subtitles {
  float: left;
}

.circle-info {
  width: 20px;
  float: left;
  margin-left: 5px;
  cursor: pointer;
}

.circle-info:hover {
  opacity: 0.7;
}

.p-r-0 {
  padding-right: 0px !important;
}

.place-holder-text-area {
  color: #c2c2c2;
}

.toggle-check .control {
  display: block;
}

.card-height {
  /* min-height: 1200px !important; */
  height: calc(100% - 1.875rem);
}

.tab-container-tags {
  margin-top: 15px;
}

.tab-container-tags-item i {
  color: #752de6;
}

.tab-container-tags-item {
  float: left;
  border: 1px solid #f2ecfd;
  color: #752de6;
  font-size: 16px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;
}

.tags-item-active {
  background: #752de6;
  color: #fff;
}

.tags-item-active i {
  color: #fff;
}

.card-list-holiday-buttons {
  margin-top: 15px;
  margin-bottom: 15px;
}

.to-right {
  float: right !important;
}

.hide-tab-holiday {
  display: none;
  -webkit-transition: display 0.1s ease-in;
  -moz-transition: display 0.1s ease-in;
  -ms-transition: display 0.1s ease-in;
  -o-transition: display 0.1s ease-in;
  transition: display 0.1s ease-in;
}

.show-tab-holiday {
  display: block;
}

.darkmode .modal-content,
.darkmode .card,
.darkmode .card-footer {
  background-color: var(--background-2) !important;
}

.darkmode span {
  color: #fff !important;
}

.darkmode .card-subtitles {
  color: #fff !important;
}

.darkmode .card-bottom-btns-save-icon h4 {
  color: #fff !important;
}

.darkmode .card-holiday {
  background: var(--background-3) !important;
}

.darkmode .card-holiday-title span {
  color: #fff !important;
}

#system_settings {
  fill: var(--clr-yup-purple);
}

.darkmode #system_settings {
  fill: #fff;
}

.tab-item-name,
.tag-item-name {
  margin-right: auto;
  color: var(--foreground);
}

.left-title {
  color: #0d0519;
  font-size: 16px;
  font-weight: 700;
}

.control .control_indicator {
  margin-right: 0px;
}

.padding-0 {
  padding: 0px !important;
}

.margin-0 {
  margin: 0px !important;
}

.icon-calendar-list {
  color: #697077;
  font-size: 20px;
  float: left;
}

.holiday-department {
  color: #0d0519;
  font-size: 14px;
  font-weight: 400;
  margin-top: 0px;
  float: left;
  margin-left: 5px;
}

.holiday-days {
  font-weight: 200;
  float: left;
  font-size: 13px;
  margin-right: 5px;
  display: block;
  background: #807c8d14;
  padding: 4px 8px 4px 8px;
  border-radius: 8px;
}

.tag-vars {
  background: #807c8d14;
  border-radius: 8px;
  display: block;
  float: left;
  padding: 4px 8px 4px 8px;
  margin-right: 10px;
  color: #807c8d;
  font-size: 12px;
  font-weight: 400;
}

.holiday-closed {
  background: #e5e5e5;
  border-radius: 4px;
  color: #697077;
  padding: 8px !important;
}

.holiday-closed span {
  margin-right: 5px;
  float: left;
}

.input-date {
  color: #aaaaaa;
  text-align: right;
}

.date-label {
  position: absolute;
  color: #595959;
  font-size: 14px;
  font-weight: 400;
  left: 15px;
  top: 8px;
}

.time-label span {
  float: left;
  font-size: 12px;
  color: #595959;
  display: block;
}

.time-label .material-symbols-outlined {
  font-size: 15px;
  font-size: 22px;
  margin-right: 5px;
  color: #697077;
}

.time-label {
  color: #595959;
  font-size: 12px;
  font-weight: 400;
}

.time-label-span {
  margin-top: 3px;
}

.calendar-container {
  border-radius: 8px;
  padding: 24px;
  border: solid 1px #e5e5e5;
}

.label-info-calendar {
  color: #aaaaaa;
  font-size: 12px;
  font-weight: 400;
}

.calendar-container {
  &::v-deep {
    .p-calendar {
      width: 100%;
    }
  }
}

.p-calendar {
  &::v-deep {
    .p-datepicker {
      border: none !important;
    }

    .p-datepicker-month.p-link {
      background: none;
      border: none;
      color: #0d0519;
      font-size: 15px;
      font-weight: 700;
    }

    .p-datepicker-year.p-link {
      background: none;
      border: none;
      color: #0d0519;
      font-size: 15px;
      font-weight: 700;
    }

    .p-datepicker-prev.p-link {
      background: url('/assets/img/icons/angle-down-solid-left.png') !important;
      background-repeat: no-repeat !important;
      background-size: auto !important;
      background-position: center !important;
    }

    .p-datepicker-next.p-link {
      background: url('/assets/img/icons/angle-down-solid-right.png') !important;
      background-repeat: no-repeat !important;
      background-size: auto !important;
      background-position: center !important;
    }

    .p-datepicker table td.p-datepicker-today > span {
      background: #752de6;
      color: #fbfbfb;
      border-color: transparent;
      border-radius: 20%;
    }
  }
}

.calendar-container-time {
  height: 488px;
}

.card-holiday-info-days span {
  color: #595959;
  font-size: 14px;
  font-weight: 400;
}

.card-holiday-info-days h4 {
  color: #595959;
  font-size: 40px;
  font-weight: 400;
  margin-bottom: 0;
}

.department-name-holiday {
  height: 50px;
  margin: 0px !important;
  margin-top: 0px;
  padding: 0px;
  padding-top: 0px;
  padding-left: 0px;
  border-left: 1px #e5e5e5 solid;
  padding-left: 20px;
  margin-top: 10px !important;
  padding-top: 15px;
}

.info-stack {
  color: #e5e5e5;
  display: inline-block;
  margin-top: -3px;
  float: left;
  margin-left: 5px;
  cursor: default;
  position: relative;
}

.image-tooltip-system {
  position: absolute;
  display: none;
  left: 70px;
  z-index: 2;
}

.info-quee:hover .image-tooltip-system {
  display: block !important;
}

.info-list:hover .image-tooltip-system {
  display: block !important;
}

.font-close {
  font-size: 18px;
  float: right;
}

.clock-input {
  position: relative;
}

.clock-input span {
  position: absolute;
  right: 0px;
  top: 10px;
  color: #aaa;
}

.clock-input input {
  border: dashed 1px #e5e5e5 !important;
  height: 44px;
  border-radius: 8px;
}

.advance-button {
  margin: 0 auto;
  width: 200px;
  text-align: center;
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  padding-left: 20px;
}

.advance-button h2 {
  color: #697077;
  font-size: 16px;
  font-weight: 700;
  margin-top: 1px;
}

.advance-button span {
  color: #697077;
}

@media (max-width: 1185px) {
  .calendar-container-time {
    &::v-deep {
      .outside-click-container {
        left: 0px !important;
      }

      .interval-container {
        display: none;
      }
    }
  }
}

@media (max-width: 982px) {
  .calendar-container-time {
    margin-top: 20px;
    width: 45%;
  }
}

.strong-hours {
  display: flex;
  flex-direction: column;
}

.hours-container {
  margin-bottom: 15px;
}

.hour-title-slide {
  font-size: 25px;
  font-weight: 400;
  margin-bottom: 20px;
  margin-top: 20px;
}

.hours-container .holiday-days {
  width: 90px;
  text-align: center;
}
.limit-input::-webkit-datetime-edit-ampm-field {
  display: none;
}
.limit-input::-webkit-calendar-picker-indicator {
  background: none;
}
.tab-card {
  padding: 10px;
  border-radius: 8px;
  border: solid 1px #e2e2e2;
  margin-bottom: 10px;
}
.tag-vars {
  margin-bottom: 5px;
}

.tag-vars-dragable {
  cursor: move;
}
.tag-vars:hover {
  background: #00000014;
}
.icon-delete {
  margin-left: 10px;
  color: #c6c6c6;
  font-size: 16px;
}
.icon-delete-tag {
  margin-left: 5px;
  color: #c6c6c6;
  font-size: 16px;
}
</style>
